/*! Axios v1.21.0 Copyright (c) 2026 Matt Zabriskie and contributors */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.axios = factory());
})(this, (function () { 'use strict';

  function _OverloadYield(e, d) {
    this.v = e, this.k = d;
  }
  function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
    return n;
  }
  function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
  }
  function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return _arrayLikeToArray(r);
  }
  function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function _asyncGeneratorDelegate(t) {
    var e = {},
      n = false;
    function pump(e, r) {
      return n = true, r = new Promise(function (n) {
        n(t[e](r));
      }), {
        done: false,
        value: new _OverloadYield(r, 1)
      };
    }
    return e["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function () {
      return this;
    }, e.next = function (t) {
      return n ? (n = false, t) : pump("next", t);
    }, "function" == typeof t.throw && (e.throw = function (t) {
      if (n) throw n = false, t;
      return pump("throw", t);
    }), "function" == typeof t.return && (e.return = function (t) {
      return n ? (n = false, t) : pump("return", t);
    }), e;
  }
  function _asyncIterator(r) {
    var n,
      t,
      o,
      e = 2;
    for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) {
      if (t && null != (n = r[t])) return n.call(r);
      if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r));
      t = "@@asyncIterator", o = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
  }
  function AsyncFromSyncIterator(r) {
    function AsyncFromSyncIteratorContinuation(r) {
      if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
      var n = r.done;
      return Promise.resolve(r.value).then(function (r) {
        return {
          value: r,
          done: n
        };
      });
    }
    return AsyncFromSyncIterator = function (r) {
      this.s = r, this.n = r.next;
    }, AsyncFromSyncIterator.prototype = {
      s: null,
      n: null,
      next: function () {
        return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
      },
      return: function (r) {
        var n = this.s.return;
        return void 0 === n ? Promise.resolve({
          value: r,
          done: true
        }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments));
      },
      throw: function (r) {
        var n = this.s.return;
        return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments));
      }
    }, new AsyncFromSyncIterator(r);
  }
  function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
      var i = n[a](c),
        u = i.value;
    } catch (n) {
      return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
  }
  function _asyncToGenerator(n) {
    return function () {
      var t = this,
        e = arguments;
      return new Promise(function (r, o) {
        var a = n.apply(t, e);
        function _next(n) {
          asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
        }
        function _throw(n) {
          asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
        }
        _next(void 0);
      });
    };
  }
  function _awaitAsyncGenerator(e) {
    return new _OverloadYield(e, 0);
  }
  function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
  }
  function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _construct(t, e, r) {
    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [null];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && _setPrototypeOf(p, r.prototype), p;
  }
  function _defineProperties(e, r) {
    for (var t = 0; t < r.length; t++) {
      var o = r[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
  }
  function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
      writable: false
    }), e;
  }
  function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
      if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
        t && (r = t);
        var n = 0,
          F = function () {};
        return {
          s: F,
          n: function () {
            return n >= r.length ? {
              done: true
            } : {
              done: false,
              value: r[n++]
            };
          },
          e: function (r) {
            throw r;
          },
          f: F
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o,
      a = true,
      u = false;
    return {
      s: function () {
        t = t.call(r);
      },
      n: function () {
        var r = t.next();
        return a = r.done, r;
      },
      e: function (r) {
        u = true, o = r;
      },
      f: function () {
        try {
          a || null == t.return || t.return();
        } finally {
          if (u) throw o;
        }
      }
    };
  }
  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: true,
      configurable: true,
      writable: true
    }) : e[r] = t, e;
  }
  function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
  }
  function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: true,
        configurable: true
      }
    }), Object.defineProperty(t, "prototype", {
      writable: false
    }), e && _setPrototypeOf(t, e);
  }
  function _isNativeFunction(t) {
    try {
      return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
      return "function" == typeof t;
    }
  }
  function _isNativeReflectConstruct() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function () {
      return !!t;
    })();
  }
  function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
  }
  function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
      var e,
        n,
        i,
        u,
        a = [],
        f = true,
        o = false;
      try {
        if (i = (t = t.call(r)).next, 0 === l) {
          if (Object(t) !== t) return;
          f = !1;
        } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
      } catch (r) {
        o = true, n = r;
      } finally {
        try {
          if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
        } finally {
          if (o) throw n;
        }
      }
      return a;
    }
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread2(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(t);
  }
  function _regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
    var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
      var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
      return _regeneratorDefine(u, "_invoke", function (r, n, o) {
        var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = false,
          G = {
            p: 0,
            n: 0,
            v: e,
            a: d,
            f: d.bind(e, 4),
            d: function (t, r) {
              return i = t, c = 0, u = e, G.n = r, a;
            }
          };
        function d(r, n) {
          for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
            var o,
              i = p[t],
              d = G.p,
              l = i[2];
            r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
          }
          if (o || r > 1) return a;
          throw y = true, n;
        }
        return function (o, p, l) {
          if (f > 1) throw TypeError("Generator is already running");
          for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
            i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
            try {
              if (f = 2, i) {
                if (c || (o = "next"), t = i[o]) {
                  if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                  if (!t.done) return t;
                  u = t.value, c < 2 && (c = 0);
                } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                i = e;
              } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
            } catch (t) {
              i = e, c = 1, u = t;
            } finally {
              f = 1;
            }
          }
          return {
            value: t,
            done: y
          };
        };
      }(r, o, i), true), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
        return this;
      }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
      return this;
    }), _regeneratorDefine(u, "toString", function () {
      return "[object Generator]";
    }), (_regenerator = function () {
      return {
        w: i,
        m: f
      };
    })();
  }
  function _regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
      i({}, "", {});
    } catch (e) {
      i = 0;
    }
    _regeneratorDefine = function (e, r, n, t) {
      function o(r, n) {
        _regeneratorDefine(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      }
      r ? i ? i(e, r, {
        value: n,
        enumerable: !t,
        configurable: !t,
        writable: !t
      }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, _regeneratorDefine(e, r, n, t);
  }
  function _regeneratorValues(e) {
    if (null != e) {
      var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
        r = 0;
      if (t) return t.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) return {
        next: function () {
          return e && r >= e.length && (e = void 0), {
            value: e && e[r++],
            done: !e
          };
        }
      };
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
      return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
  }
  function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
  }
  function _toConsumableArray(r) {
    return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _typeof(o) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
      return typeof o;
    } : function (o) {
      return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
  }
  function _unsupportedIterableToArray(r, a) {
    if (r) {
      if ("string" == typeof r) return _arrayLikeToArray(r, a);
      var t = {}.toString.call(r).slice(8, -1);
      return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
  }
  function _wrapAsyncGenerator(e) {
    return function () {
      return new AsyncGenerator(e.apply(this, arguments));
    };
  }
  function AsyncGenerator(e) {
    var t, n;
    function resume(t, n) {
      try {
        var r = e[t](n),
          o = r.value,
          u = o instanceof _OverloadYield;
        Promise.resolve(u ? o.v : o).then(function (n) {
          if (u) {
            var i = "return" === t && o.k ? t : "next";
            if (!o.k || n.done) return resume(i, n);
            n = e[i](n).value;
          }
          settle(!!r.done, n);
        }, function (e) {
          resume("throw", e);
        });
      } catch (e) {
        settle(2, e);
      }
    }
    function settle(e, r) {
      2 === e ? t.reject(r) : t.resolve({
        value: r,
        done: e
      }), (t = t.next) ? resume(t.key, t.arg) : n = null;
    }
    this._invoke = function (e, r) {
      return new Promise(function (o, u) {
        var i = {
          key: e,
          arg: r,
          resolve: o,
          reject: u,
          next: null
        };
        n ? n = n.next = i : (t = n = i, resume(e, r));
      });
    }, "function" != typeof e.return && (this.return = void 0);
  }
  AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () {
    return this;
  }, AsyncGenerator.prototype.next = function (e) {
    return this._invoke("next", e);
  }, AsyncGenerator.prototype.throw = function (e) {
    return this._invoke("throw", e);
  }, AsyncGenerator.prototype.return = function (e) {
    return this._invoke("return", e);
  };
  function _wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return _wrapNativeSuper = function (t) {
      if (null === t || !_isNativeFunction(t)) return t;
      if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== r) {
        if (r.has(t)) return r.get(t);
        r.set(t, Wrapper);
      }
      function Wrapper() {
        return _construct(t, arguments, _getPrototypeOf(this).constructor);
      }
      return Wrapper.prototype = Object.create(t.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      }), _setPrototypeOf(Wrapper, t);
    }, _wrapNativeSuper(t);
  }

  /**
   * Create a bound version of a function with a specified `this` context
   *
   * @param {Function} fn - The function to bind
   * @param {*} thisArg - The value to be passed as the `this` parameter
   * @returns {Function} A new function that will call the original function with the specified `this` context
   */
  function bind(fn, thisArg) {
    return function wrap() {
      return fn.apply(thisArg, arguments);
    };
  }

  // utils is a library of generic helper functions non-specific to axios

  var toString = Object.prototype.toString;
  var getPrototypeOf = Object.getPrototypeOf;
  var iterator = Symbol.iterator,
    toStringTag = Symbol.toStringTag;

  /* Creating a function that will check if an object has a property. */
  var hasOwnProperty = function (_ref) {
    var hasOwnProperty = _ref.hasOwnProperty;
    return function (obj, prop) {
      return hasOwnProperty.call(obj, prop);
    };
  }(Object.prototype);
  var isUnsafeObjectKey = function isUnsafeObjectKey(prop) {
    return typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
  };

  /**
   * Determine whether an inherited object must be treated as a shared-prototype
   * boundary. Cross-realm Object.prototype objects cannot be distinguished
   * reliably from application-created null-prototype objects because their
   * properties are mutable, so all inherited terminal prototypes are excluded
   * as a fail-closed boundary. A null-prototype source still keeps its own
   * properties, as produced by mergeConfig and other safe materialization paths.
   *
   * @param {*} obj The object to inspect
   * @param {*} prototype The object's prototype
   * @param {boolean} source Whether obj is the original traversal source
   *
   * @returns {boolean} True when obj is a safe prototype traversal boundary
   */
  var isPrototypeBoundary = function isPrototypeBoundary(obj, prototype, source) {
    return obj === Object.prototype || !source && prototype === null;
  };

  /**
   * Determine whether an object can retain its identity through code paths that
   * add, replace, and remove config properties without bypassing unsafe-key
   * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
   * accessor or restricted data properties must be materialized instead.
   *
   * @param {*} obj The object to inspect
   *
   * @returns {boolean} True when every own property is safe and fully mutable
   */
  var isSafeAndFullyMutable = function isSafeAndFullyMutable(obj) {
    if (!Object.isExtensible(obj)) {
      return false;
    }
    var props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) {
      props.push.apply(props, _toConsumableArray(Object.getOwnPropertySymbols(obj)));
    }
    return props.every(function (prop) {
      if (isUnsafeObjectKey(prop)) {
        return false;
      }
      var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
      return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
  };

  /**
   * Walk the prototype chain (excluding the source realm's Object.prototype)
   * looking for an own `prop`. This distinguishes genuine own/inherited members
   * — including class accessors and template prototypes — from members injected
   * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
   * which live on Object.prototype itself and are therefore never matched.
   *
   * @param {*} thing The value whose chain to inspect
   * @param {string|symbol} prop The property key to look for
   *
   * @returns {boolean} True when `prop` is owned below Object.prototype
   */
  var hasOwnInPrototypeChain = function hasOwnInPrototypeChain(thing, prop) {
    var obj = thing;
    var seen = [];
    while (obj != null) {
      if (seen.indexOf(obj) !== -1) {
        return false;
      }
      seen.push(obj);
      var prototype = getPrototypeOf(obj);
      if (isPrototypeBoundary(obj, prototype, obj === thing)) {
        return false;
      }
      if (hasOwnProperty(obj, prop)) {
        return true;
      }
      obj = prototype;
    }
    return false;
  };

  /**
   * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
   * properties and members inherited from a non-Object.prototype source (a class
   * instance or template object) are honored; a value reachable only through a
   * polluted Object.prototype is ignored and `undefined` is returned.
   *
   * @param {*} obj The source object
   * @param {string|symbol} prop The property key to read
   *
   * @returns {*} The resolved value, or undefined when unsafe/absent
   */
  var getSafeProp = function getSafeProp(obj, prop) {
    return obj != null && hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
  };

  /**
   * Flatten an object and its application-defined prototype chain into a
   * null-prototype object. Members inherited only from the source realm's
   * Object.prototype are deliberately excluded, while class/template members
   * below that boundary are preserved.
   *
   * @param {*} thing The value to flatten
   *
   * @returns {*} A null-prototype copy, or the original value when it is already
   * structurally safe or is not an object
   */
  var toSafeFlatObject = function toSafeFlatObject(thing) {
    if (thing == null || _typeof(thing) !== 'object' && typeof thing !== 'function') {
      return thing;
    }
    var sourcePrototype = getPrototypeOf(thing);
    if (sourcePrototype === null && isSafeAndFullyMutable(thing)) {
      return thing;
    }
    var result = Object.create(null);
    var merged = Object.create(null);
    var seen = [];
    var current = thing;
    while (current != null) {
      if (seen.indexOf(current) !== -1) {
        break;
      }
      seen.push(current);
      var prototype = current === thing ? sourcePrototype : getPrototypeOf(current);
      if (isPrototypeBoundary(current, prototype, current === thing)) {
        break;
      }
      var props = Object.getOwnPropertyNames(current);
      if (Object.getOwnPropertySymbols) {
        props.push.apply(props, _toConsumableArray(Object.getOwnPropertySymbols(current)));
      }
      var _iterator2 = _createForOfIteratorHelper(props),
        _step;
      try {
        for (_iterator2.s(); !(_step = _iterator2.n()).done;) {
          var prop = _step.value;
          if (isUnsafeObjectKey(prop)) {
            continue;
          }
          if (!hasOwnProperty(merged, prop)) {
            result[prop] = thing[prop];
            merged[prop] = true;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      current = prototype;
    }
    return result;
  };
  var kindOf = function (cache) {
    return function (thing) {
      var str = toString.call(thing);
      return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
  }(Object.create(null));
  var kindOfTest = function kindOfTest(type) {
    type = type.toLowerCase();
    return function (thing) {
      return kindOf(thing) === type;
    };
  };
  var typeOfTest = function typeOfTest(type) {
    return function (thing) {
      return _typeof(thing) === type;
    };
  };

  /**
   * Determine if a value is a non-null object
   *
   * @param {Object} val The value to test
   *
   * @returns {boolean} True if value is an Array, otherwise false
   */
  var isArray = Array.isArray;

  /**
   * Determine if a value is undefined
   *
   * @param {*} val The value to test
   *
   * @returns {boolean} True if the value is undefined, otherwise false
   */
  var isUndefined = typeOfTest('undefined');

  /**
   * Determine if a value is a Buffer
   *
   * @param {*} val The value to test
   *
   * @returns {boolean} True if value is a Buffer, otherwise false
   */
  function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction$1(val.constructor.isBuffer) && val.constructor.isBuffer(val);
  }

  /**
   * Determine if a value is an ArrayBuffer
   *
   * @param {*} val The value to test
   *
   * @returns {boolean} True if value is an ArrayBuffer, otherwise false
   */
  var isArrayBuffer = kindOfTest('ArrayBuffer');

  /**
   * Determine if a value is a view on an ArrayBuffer
   *
   * @param {*} val The value to test
   *
   * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
   */
  function isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
      result = ArrayBuffer.isView(val);
    } else {
      result = val && val.buffer && isArrayBuffer(val.buffer);
    }
    return result;
  }

  /**
   * Determine if a value is a String
   *
   * @param {*} val The value to test
   *
   * @returns {boolean} True if value is a String, otherwise false
   */
  var isString = typeOfTest('string');

  /**
   * Determine if a value is a Function
   *
   * @param {*} val The value to test
   * @returns {boolean} True if value is a Function, otherwise false
   */
  var isFunction$1 = typeOfTest('function');

  /**
   * Determine if a value is a Number
   *
   * @param {*} val The value to test
   *
   * @returns {boolean} True if value is a Number, otherwise false
   */
  var isNumber = typeOfTest('number');

  /**
   * Determine if a value is an Object
   *
   * @param {*} thing The value to test
   *
   * @returns {boolean} True if value is an Object, otherwise false
   */
  var isObject = function isObject(thing) {
    return thing !== null && _typeof(thing) === 'object';
  };

  /**
   * Determine if a value is a Boolean
   *
   * @param {*} thing The value to test
   * @returns {boolean} True if value is a Boolean, otherwise false
   */
  var isBoolean = function isBoolean(thing) {
    return thing === true || thing === false;
  };

  /**
   * Determine if a value is a plain Object
   *
   * @param {*} val The value to test
   *
   * @returns {boolean} True if value is a plain Object, otherwise false
   */
  var isPlainObject = function isPlainObject(val) {
    if (!isObject(val)) {
      return false;
    }
    var prototype = getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || getPrototypeOf(prototype) === null) && (
    // Treat own Symbol.toStringTag or Symbol.iterator members as evidence the
    // value is tagged/iterable, ignoring members reachable only through shared
    // or terminal prototype boundaries. This is exactly what
    // hasOwnInPrototypeChain(val, prop) computes here: every prototype admitted
    // above (null, Object.prototype, or a terminal null-prototype template) is
    // a boundary, so the walk never inspects anything but `val`'s own members,
    // and stops before even those when `val` is itself the boundary
    // Object.prototype. Checking that inline avoids allocating the walker's
    // `seen` list twice per call on the mergeConfig / merge hot path.
    isPrototypeBoundary(val, prototype, true) || !hasOwnProperty(val, toStringTag) && !hasOwnProperty(val, iterator));
  };

  /**
   * Determine if a value is an empty object (safely handles Buffers)
   *
   * @param {*} val The value to test
   *
   * @returns {boolean} True if value is an empty object, otherwise false
   */
  var isEmptyObject = function isEmptyObject(val) {
    // Early return for non-objects or Buffers to prevent RangeError
    if (!isObject(val) || isBuffer(val)) {
      return false;
    }
    try {
      return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
      // Fallback for any other objects that might cause RangeError with Object.keys()
      return false;
    }
  };

  /**
   * Determine if a value is a Date
   *
   * @param {*} val The value to test
   *
   * @returns {boolean} True if value is a Date, otherwise false
   */
  var isDate = kindOfTest('Date');

  /**
   * Determine if a value is a File
   *
   * @param {*} val The value to test
   *
   * @returns {boolean} True if value is a File, otherwise false
   */
  var isFile = kindOfTest('File');

  /**
   * Determine if a value is a React Native Blob
   * React Native "blob": an object with a `uri` attribute. Optionally, it can
   * also have a `name` and `type` attribute to specify filename and content type
   *
   * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
   *
   * @param {*} value The value to test
   *
   * @returns {boolean} True if value is a React Native Blob, otherwise false
   */
  var isReactNativeBlob = function isReactNativeBlob(value) {
    return !!(value && typeof value.uri !== 'undefined');
  };

  /**
   * Determine if environment is React Native
   * ReactNative `FormData` has a non-standard `getParts()` method
   *
   * @param {*} formData The formData to test
   *
   * @returns {boolean} True if environment is React Native, otherwise false
   */
  var isReactNative = function isReactNative(formData) {
    return formData && typeof formData.getParts !== 'undefined';
  };

  /**
   * Determine if a value is a Blob
   *
   * @param {*} val The value to test
   *
   * @returns {boolean} True if value is a Blob, otherwise false
   */
  var isBlob = kindOfTest('Blob');

  /**
   * Determine if a value is a FileList
   *
   * @param {*} val The value to test
   *
   * @returns {boolean} True if value is a FileList, otherwise false
   */
  var isFileList = kindOfTest('FileList');
  var isSet = kindOfTest('Set');

  /**
   * Determine if a value is a Stream
   *
   * @param {*} val The value to test
   *
   * @returns {boolean} True if value is a Stream, otherwise false
   */
  var isStream = function isStream(val) {
    return isObject(val) && isFunction$1(val.pipe);
  };

  /**
   * Determine if a value is a FormData
   *
   * @param {*} thing The value to test
   *
   * @returns {boolean} True if value is an FormData, otherwise false
   */
  function getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof global !== 'undefined') return global;
    return {};
  }
  var G = getGlobal();
  var FormDataCtor = typeof G.FormData !== 'undefined' ? G.FormData : undefined;
  var isFormData = function isFormData(thing) {
    if (!thing) return false;
    if (FormDataCtor && thing instanceof FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    var proto = getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!isFunction$1(thing.append)) return false;
    var kind = kindOf(thing);
    return kind === 'formdata' ||
    // detect form-data instance
    kind === 'object' && isFunction$1(thing.toString) && thing.toString() === '[object FormData]';
  };

  /**
   * Determine if a value is a URLSearchParams object
   *
   * @param {*} val The value to test
   *
   * @returns {boolean} True if value is a URLSearchParams object, otherwise false
   */
  var isURLSearchParams = kindOfTest('URLSearchParams');
  var _map = ['ReadableStream', 'Request', 'Response', 'Headers'].map(kindOfTest),
    _map2 = _slicedToArray(_map, 4),
    isReadableStream = _map2[0],
    isRequest = _map2[1],
    isResponse = _map2[2],
    isHeaders = _map2[3];

  /**
   * Trim excess whitespace off the beginning and end of a string
   *
   * @param {String} str The String to trim
   *
   * @returns {String} The String freed of excess whitespace
   */
  var trim = function trim(str) {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  };
  /**
   * Iterate over an Array or an Object invoking a function for each item.
   *
   * If `obj` is an Array callback will be called passing
   * the value, index, and complete array for each item.
   *
   * If 'obj' is an Object callback will be called passing
   * the value, key, and complete object for each property.
   *
   * @param {Object|Array<unknown>} obj The object to iterate
   * @param {Function} fn The callback to invoke for each item
   *
   * @param {Object} [options]
   * @param {Boolean} [options.allOwnKeys = false]
   * @returns {any}
   */
  function forEach(obj, fn) {
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$allOwnKeys = _ref2.allOwnKeys,
      allOwnKeys = _ref2$allOwnKeys === void 0 ? false : _ref2$allOwnKeys;
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') {
      return;
    }
    var i;
    var l;

    // Force an array if not already something iterable
    if (_typeof(obj) !== 'object') {
      /*eslint no-param-reassign:0*/
      obj = [obj];
    }
    if (isArray(obj)) {
      // Iterate over array values
      for (i = 0, l = obj.length; i < l; i++) {
        fn.call(null, obj[i], i, obj);
      }
    } else {
      // Buffer check
      if (isBuffer(obj)) {
        return;
      }

      // Iterate over object keys
      var keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
      var len = keys.length;
      var key;
      for (i = 0; i < len; i++) {
        key = keys[i];
        fn.call(null, obj[key], key, obj);
      }
    }
  }

  /**
   * Finds a key in an object, case-insensitive, returning the actual key name.
   * Returns null if the object is a Buffer or if no match is found.
   *
   * @param {Object} obj - The object to search.
   * @param {string} key - The key to find (case-insensitive).
   * @returns {?string} The actual key name if found, otherwise null.
   */
  function findKey(obj, key) {
    if (isBuffer(obj)) {
      return null;
    }
    key = key.toLowerCase();
    var keys = Object.keys(obj);
    var i = keys.length;
    var _key;
    while (i-- > 0) {
      _key = keys[i];
      if (key === _key.toLowerCase()) {
        return _key;
      }
    }
    return null;
  }
  var _global = function () {
    /*eslint no-undef:0*/
    if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : global;
  }();
  var isContextDefined = function isContextDefined(context) {
    return !isUndefined(context) && context !== _global;
  };

  /**
   * Accepts varargs expecting each argument to be an object, then
   * immutably merges the properties of each object and returns result.
   *
   * When multiple objects contain the same key the later object in
   * the arguments list will take precedence.
   *
   * Example:
   *
   * ```js
   * const result = merge({foo: 123}, {foo: 456});
   * console.log(result.foo); // outputs 456
   * ```
   *
   * @param {Object} obj1 Object to merge
   *
   * @returns {Object} Result of all merge properties
   */
  function merge() {
    var _ref3 = isContextDefined(this) && this || {},
      caseless = _ref3.caseless,
      skipUndefined = _ref3.skipUndefined;
    var result = {};
    // Caseless lookup only applies to string keys — symbol keys are
    // identity-matched. Every string key that reaches `result` passes through
    // this index first, so it can never hold two case variants of one key and a
    // lowercase -> key map is exactly what findKey(result, key) would rescan
    // Object.keys(result) for on each assignment.
    var lowerCaseKeys = caseless ? Object.create(null) : null;
    var assignValue = function assignValue(val, key) {
      // Skip dangerous property names to prevent prototype pollution
      if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
        return;
      }
      var targetKey = key;
      if (lowerCaseKeys && typeof key === 'string') {
        var lowerKey = key.toLowerCase();
        var knownKey = lowerCaseKeys[lowerKey];
        // A key recorded but absent from `result` was skipped by skipUndefined;
        // the later spelling wins then, as it does for findKey.
        if (knownKey !== undefined && hasOwnProperty(result, knownKey)) {
          targetKey = knownKey;
        } else {
          lowerCaseKeys[lowerKey] = key;
        }
      }
      // Read via own-prop only — a bare `result[targetKey]` walks the prototype
      // chain, so a polluted Object.prototype value could surface here and get
      // copied into the merged result.
      var existing = hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
      if (isPlainObject(existing) && isPlainObject(val)) {
        result[targetKey] = merge(existing, val);
      } else if (isPlainObject(val)) {
        result[targetKey] = merge({}, val);
      } else if (isArray(val)) {
        result[targetKey] = val.slice();
      } else if (!skipUndefined || !isUndefined(val)) {
        result[targetKey] = val;
      }
    };
    for (var i = 0, l = arguments.length; i < l; i++) {
      var source = i < 0 || arguments.length <= i ? undefined : arguments[i];
      if (!source || isBuffer(source)) {
        continue;
      }
      forEach(source, assignValue);
      if (_typeof(source) !== 'object' || isArray(source) || !Object.getOwnPropertySymbols) {
        continue;
      }
      var symbols = Object.getOwnPropertySymbols(source);
      for (var j = 0; j < symbols.length; j++) {
        var symbol = symbols[j];
        if (propertyIsEnumerable.call(source, symbol)) {
          assignValue(source[symbol], symbol);
        }
      }
    }
    return result;
  }

  /**
   * Extends object a by mutably adding to it the properties of object b.
   *
   * @param {Object} a The object to be extended
   * @param {Object} b The object to copy properties from
   * @param {Object} thisArg The object to bind function to
   *
   * @param {Object} [options]
   * @param {Boolean} [options.allOwnKeys]
   * @returns {Object} The resulting value of object a
   */
  var extend = function extend(a, b, thisArg) {
    var _ref4 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      allOwnKeys = _ref4.allOwnKeys;
    forEach(b, function (val, key) {
      if (thisArg && isFunction$1(val)) {
        Object.defineProperty(a, key, {
          // Null-proto descriptor so a polluted Object.prototype.get cannot
          // hijack defineProperty's accessor-vs-data resolution.
          __proto__: null,
          value: bind(val, thisArg),
          writable: true,
          enumerable: true,
          configurable: true
        });
      } else {
        Object.defineProperty(a, key, {
          __proto__: null,
          value: val,
          writable: true,
          enumerable: true,
          configurable: true
        });
      }
    }, {
      allOwnKeys: allOwnKeys
    });
    return a;
  };

  /**
   * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
   *
   * @param {string} content with BOM
   *
   * @returns {string} content value without BOM
   */
  var stripBOM = function stripBOM(content) {
    if (content.charCodeAt(0) === 0xfeff) {
      content = content.slice(1);
    }
    return content;
  };

  /**
   * Inherit the prototype methods from one constructor into another
   * @param {function} constructor
   * @param {function} superConstructor
   * @param {object} [props]
   * @param {object} [descriptors]
   *
   * @returns {void}
   */
  var inherits = function inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
      __proto__: null,
      value: constructor,
      writable: true,
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(constructor, 'super', {
      __proto__: null,
      value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
  };

  /**
   * Resolve object with deep prototype chain to a flat object
   * @param {Object} sourceObj source object
   * @param {Object} [destObj]
   * @param {Function|Boolean} [filter]
   * @param {Function} [propFilter]
   *
   * @returns {Object}
   */
  var toFlatObject = function toFlatObject(sourceObj, destObj, filter, propFilter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
      props = Object.getOwnPropertyNames(sourceObj);
      i = props.length;
      while (i-- > 0) {
        prop = props[i];
        if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
          destObj[prop] = sourceObj[prop];
          merged[prop] = true;
        }
      }
      sourceObj = filter !== false && getPrototypeOf(sourceObj);
    } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
  };

  /**
   * Determines whether a string ends with the characters of a specified string
   *
   * @param {String} str
   * @param {String} searchString
   * @param {Number} [position= 0]
   *
   * @returns {boolean}
   */
  var endsWith = function endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) {
      position = str.length;
    }
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };

  /**
   * Returns new array from array like object or null if failed
   *
   * @param {*} [thing]
   *
   * @returns {?Array}
   */
  var toArray = function toArray(thing) {
    if (!thing) return null;
    if (isArray(thing)) return thing;
    var i = thing.length;
    if (!Number.isSafeInteger(i) || i < 0 || i > 0xffffffff) return null;

    // Bound the copy by actual indexed properties, including hidden and inherited
    // members of array-like collections, rather than by the declared length alone.
    var indexes = new Set();
    var seen = new Set();
    var source = thing;
    while (source != null && indexes.size < i) {
      if (seen.has(source)) return null;
      seen.add(source);
      var prototype = getPrototypeOf(source);
      if (isPrototypeBoundary(source, prototype, source === thing)) break;
      Object.getOwnPropertyNames(source).forEach(function (key) {
        var index = +key;
        if (Number.isInteger(index) && index >= 0 && index < i && String(index) === key && hasOwnProperty(source, key)) {
          indexes.add(index);
        }
      });
      source = prototype;
    }
    if (indexes.size !== i) return null;
    var arr = new Array(i);
    while (i-- > 0) {
      arr[i] = thing[i];
    }
    return arr;
  };

  /**
   * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
   * thing passed in is an instance of Uint8Array
   *
   * @param {TypedArray}
   *
   * @returns {Array}
   */
  // eslint-disable-next-line func-names
  var isTypedArray = function (TypedArray) {
    // eslint-disable-next-line func-names
    return function (thing) {
      return TypedArray && thing instanceof TypedArray;
    };
  }(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

  /**
   * For each entry in the object, call the function with the key and value.
   *
   * @param {Object<any, any>} obj - The object to iterate over.
   * @param {Function} fn - The function to call for each entry.
   *
   * @returns {void}
   */
  var forEachEntry = function forEachEntry(obj, fn) {
    var generator = obj && obj[iterator];
    var _iterator = generator.call(obj);
    var result;
    while ((result = _iterator.next()) && !result.done) {
      var pair = result.value;
      fn.call(obj, pair[0], pair[1]);
    }
  };

  /**
   * It takes a regular expression and a string, and returns an array of all the matches
   *
   * @param {string} regExp - The regular expression to match against.
   * @param {string} str - The string to search.
   *
   * @returns {Array<boolean>}
   */
  var matchAll = function matchAll(regExp, str) {
    var matches;
    var arr = [];
    while ((matches = regExp.exec(str)) !== null) {
      arr.push(matches);
    }
    return arr;
  };

  /* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
  var isHTMLForm = kindOfTest('HTMLFormElement');
  var toCamelCase = function toCamelCase(str) {
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    });
  };
  var propertyIsEnumerable = Object.prototype.propertyIsEnumerable;

  /**
   * Determine if a value is a RegExp object
   *
   * @param {*} val The value to test
   *
   * @returns {boolean} True if value is a RegExp object, otherwise false
   */
  var isRegExp = kindOfTest('RegExp');
  var reduceDescriptors = function reduceDescriptors(obj, reducer) {
    var descriptors = Object.getOwnPropertyDescriptors(obj);
    var reducedDescriptors = {};
    forEach(descriptors, function (descriptor, name) {
      var ret;
      if ((ret = reducer(descriptor, name, obj)) !== false) {
        reducedDescriptors[name] = ret || descriptor;
      }
    });
    Object.defineProperties(obj, reducedDescriptors);
  };

  /**
   * Makes all methods read-only
   * @param {Object} obj
   */

  var freezeMethods = function freezeMethods(obj) {
    reduceDescriptors(obj, function (descriptor, name) {
      // skip restricted props in strict mode
      if (isFunction$1(obj) && ['arguments', 'caller', 'callee'].includes(name)) {
        return false;
      }
      var value = obj[name];
      if (!isFunction$1(value)) return;
      descriptor.enumerable = false;
      if ('writable' in descriptor) {
        descriptor.writable = false;
        return;
      }
      if (!descriptor.set) {
        descriptor.set = function () {
          throw Error("Can not rewrite read-only method '" + name + "'");
        };
      }
    });
  };

  /**
   * Converts an array or a delimited string into an object set with values as keys and true as values.
   * Useful for fast membership checks.
   *
   * @param {Array|string} arrayOrString - The array or string to convert.
   * @param {string} delimiter - The delimiter to use if input is a string.
   * @returns {Object} An object with keys from the array or string, values set to true.
   */
  var toObjectSet = function toObjectSet(arrayOrString, delimiter) {
    var obj = {};
    var define = function define(arr) {
      arr.forEach(function (value) {
        obj[value] = true;
      });
    };
    isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
  };
  var noop = function noop() {};
  var toFiniteNumber = function toFiniteNumber(value, defaultValue) {
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
  };

  /**
   * If the thing is a FormData object, return true, otherwise return false.
   *
   * @param {unknown} thing - The thing to check.
   *
   * @returns {boolean}
   */
  function isSpecCompliantForm(thing) {
    return !!(thing && isFunction$1(thing.append) && thing[toStringTag] === 'FormData' && thing[iterator]);
  }

  /**
   * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
   *
   * @param {Object} obj - The object to convert.
   * @returns {Object} The JSON-compatible object.
   */
  var toJSONObject = function toJSONObject(obj) {
    var visited = new WeakSet();
    var _visit = function visit(source) {
      if (isObject(source)) {
        if (visited.has(source)) {
          return;
        }

        //Buffer check
        if (isBuffer(source)) {
          return source;
        }
        if (!('toJSON' in source)) {
          // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
          visited.add(source);
          var target;
          if (isSet(source)) {
            target = [];
            var _iterator3 = _createForOfIteratorHelper(source),
              _step2;
            try {
              for (_iterator3.s(); !(_step2 = _iterator3.n()).done;) {
                var value = _step2.value;
                var reducedValue = _visit(value);
                !isUndefined(reducedValue) && target.push(reducedValue);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          } else {
            target = isArray(source) ? [] : {};
            forEach(source, function (value, key) {
              var reducedValue = _visit(value);
              !isUndefined(reducedValue) && (target[key] = reducedValue);
            });
          }
          visited["delete"](source);
          return target;
        }
      }
      return source;
    };
    return _visit(obj);
  };

  /**
   * Determines if a value is an async function.
   *
   * @param {*} thing - The value to test.
   * @returns {boolean} True if value is an async function, otherwise false.
   */
  var isAsyncFn = kindOfTest('AsyncFunction');

  /**
   * Determines if a value is thenable (has then and catch methods).
   *
   * @param {*} thing - The value to test.
   * @returns {boolean} True if value is thenable, otherwise false.
   */
  var isThenable = function isThenable(thing) {
    return thing && (isObject(thing) || isFunction$1(thing)) && isFunction$1(thing.then) && isFunction$1(thing["catch"]);
  };

  // original code
  // https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34

  /**
   * Provides a cross-platform setImmediate implementation.
   * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
   *
   * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
   * @param {boolean} postMessageSupported - Whether postMessage is supported.
   * @returns {Function} A function to schedule a callback asynchronously.
   */
  var _setImmediate = function (setImmediateSupported, postMessageSupported) {
    if (setImmediateSupported) {
      return setImmediate;
    }
    return postMessageSupported ? function (token, callbacks) {
      _global.addEventListener('message', function (_ref5) {
        var source = _ref5.source,
          data = _ref5.data;
        if (source === _global && data === token) {
          callbacks.length && callbacks.shift()();
        }
      }, false);
      return function (cb) {
        callbacks.push(cb);
        _global.postMessage(token, '*');
      };
    }("axios@".concat(Math.random()), []) : function (cb) {
      return setTimeout(cb);
    };
  }(typeof setImmediate === 'function', isFunction$1(_global.postMessage));

  /**
   * Schedules a microtask or asynchronous callback as soon as possible.
   * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
   *
   * @type {Function}
   */
  var asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind(_global) : typeof process !== 'undefined' && process.nextTick || _setImmediate;

  // *********************

  var isIterable = function isIterable(thing) {
    return thing != null && isFunction$1(thing[iterator]);
  };

  /**
   * Determine if a value is iterable via an iterator that is NOT sourced solely
   * from a polluted Object.prototype. Use this instead of `isIterable` whenever
   * the iterable comes from untrusted input (e.g. user-supplied header sources),
   * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
   * into an attacker-controlled entries iterator.
   *
   * @param {*} thing The value to test
   *
   * @returns {boolean} True if value has a non-polluted iterator
   */
  var isSafeIterable = function isSafeIterable(thing) {
    return thing != null && hasOwnInPrototypeChain(thing, iterator) && isIterable(thing);
  };
  var utils$1 = {
    isArray: isArray,
    isArrayBuffer: isArrayBuffer,
    isBuffer: isBuffer,
    isFormData: isFormData,
    isArrayBufferView: isArrayBufferView,
    isString: isString,
    isNumber: isNumber,
    isBoolean: isBoolean,
    isObject: isObject,
    isPlainObject: isPlainObject,
    isEmptyObject: isEmptyObject,
    isReadableStream: isReadableStream,
    isRequest: isRequest,
    isResponse: isResponse,
    isHeaders: isHeaders,
    isUndefined: isUndefined,
    isDate: isDate,
    isFile: isFile,
    isReactNativeBlob: isReactNativeBlob,
    isReactNative: isReactNative,
    isBlob: isBlob,
    isRegExp: isRegExp,
    isFunction: isFunction$1,
    isStream: isStream,
    isURLSearchParams: isURLSearchParams,
    isTypedArray: isTypedArray,
    isFileList: isFileList,
    forEach: forEach,
    merge: merge,
    extend: extend,
    trim: trim,
    stripBOM: stripBOM,
    inherits: inherits,
    toFlatObject: toFlatObject,
    kindOf: kindOf,
    kindOfTest: kindOfTest,
    endsWith: endsWith,
    toArray: toArray,
    forEachEntry: forEachEntry,
    matchAll: matchAll,
    isHTMLForm: isHTMLForm,
    hasOwnProperty: hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    // an alias to avoid ESLint no-prototype-builtins detection
    hasOwnInPrototypeChain: hasOwnInPrototypeChain,
    getSafeProp: getSafeProp,
    toSafeFlatObject: toSafeFlatObject,
    reduceDescriptors: reduceDescriptors,
    freezeMethods: freezeMethods,
    toObjectSet: toObjectSet,
    toCamelCase: toCamelCase,
    noop: noop,
    toFiniteNumber: toFiniteNumber,
    findKey: findKey,
    global: _global,
    isContextDefined: isContextDefined,
    isSpecCompliantForm: isSpecCompliantForm,
    toJSONObject: toJSONObject,
    isAsyncFn: isAsyncFn,
    isThenable: isThenable,
    setImmediate: _setImmediate,
    asap: asap,
    isIterable: isIterable,
    isSafeIterable: isSafeIterable
  };

  // RawAxiosHeaders whose duplicates are ignored by node
  // c.f. https://nodejs.org/api/http.html#http_message_headers
  var ignoreDuplicateOf = utils$1.toObjectSet(['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent']);

  /**
   * Parse headers into an object
   *
   * ```
   * Date: Wed, 27 Aug 2014 08:58:49 GMT
   * Content-Type: application/json
   * Connection: keep-alive
   * Transfer-Encoding: chunked
   * ```
   *
   * @param {String} rawHeaders Headers needing to be parsed
   *
   * @returns {Object} Headers parsed into an object
   */
  var parseHeaders = (function (rawHeaders) {
    // Header names are data, including __proto__; avoid inherited setters.
    var parsed = Object.create(null);
    var key;
    var val;
    var i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
      i = line.indexOf(':');
      key = line.substring(0, i).trim().toLowerCase();
      val = line.substring(i + 1).trim();
      var hasKey = utils$1.hasOwnProp(parsed, key);
      if (!key || hasKey && utils$1.hasOwnProp(ignoreDuplicateOf, key)) {
        return;
      }
      if (key === 'set-cookie') {
        if (hasKey) {
          parsed[key].push(val);
        } else {
          parsed[key] = [val];
        }
      } else {
        parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
      }
    });
    return parsed;
  });

  function trimSPorHTAB(str) {
    var start = 0;
    var end = str.length;
    while (start < end) {
      var code = str.charCodeAt(start);
      if (code !== 0x09 && code !== 0x20) {
        break;
      }
      start += 1;
    }
    while (end > start) {
      var _code = str.charCodeAt(end - 1);
      if (_code !== 0x09 && _code !== 0x20) {
        break;
      }
      end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
  }

  // The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
  // eslint-disable-next-line no-control-regex
  var INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", 'g');
  // eslint-disable-next-line no-control-regex
  var INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", 'g');
  function sanitizeValue(value, invalidChars) {
    if (utils$1.isArray(value)) {
      return value.map(function (item) {
        return sanitizeValue(item, invalidChars);
      });
    }
    return trimSPorHTAB(String(value).replace(invalidChars, ''));
  }
  var sanitizeHeaderValue = function sanitizeHeaderValue(value) {
    return sanitizeValue(value, INVALID_UNICODE_HEADER_VALUE_CHARS);
  };
  var sanitizeByteStringHeaderValue = function sanitizeByteStringHeaderValue(value) {
    return sanitizeValue(value, INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
  };
  function toByteStringHeaderObject(headers) {
    var byteStringHeaders = Object.create(null);
    utils$1.forEach(headers.toJSON(), function (value, header) {
      byteStringHeaders[header] = sanitizeByteStringHeaderValue(value);
    });
    return byteStringHeaders;
  }

  var $internals$1 = Symbol('internals');
  function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
  }
  function normalizeValue(value) {
    if (value === false || value == null) {
      return value;
    }
    return utils$1.isArray(value) ? value.map(normalizeValue) : sanitizeHeaderValue(String(value));
  }
  function parseTokens(str) {
    var tokens = Object.create(null);
    var tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    var match;
    while (match = tokensRE.exec(str)) {
      tokens[match[1]] = match[2];
    }
    return tokens;
  }
  var parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
  function trimOWS(value) {
    var start = 0;
    var end = value.length;
    while (start < end) {
      var code = value.charCodeAt(start);
      if (code !== 0x09 && code !== 0x20) {
        break;
      }
      start += 1;
    }
    while (end > start) {
      var _code = value.charCodeAt(end - 1);
      if (_code !== 0x09 && _code !== 0x20) {
        break;
      }
      end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
  }
  function decodeQuotedString(value) {
    var last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) {
      return value;
    }
    var decoded = '';
    for (var i = 1; i < last; i++) {
      var code = value.charCodeAt(i);
      if (code === 0x22) {
        return value;
      }
      if (code === 0x5c) {
        i += 1;
        if (i >= last) {
          return value;
        }
      }
      decoded += value[i];
    }
    return decoded;
  }
  function _parseParameters(value) {
    var parameters = Object.create(null);
    var str = String(value);
    var start = 0;
    var quoted = false;
    var escaped = false;
    function parseParameter(end) {
      var part = trimOWS(str.slice(start, end));
      var equals = part.indexOf('=');
      if (equals < 1) {
        return;
      }
      var name = trimOWS(part.slice(0, equals));
      if (!parameterNameRE.test(name)) {
        return;
      }
      var normalizedName = name.toLowerCase();
      if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') {
        return;
      }
      var parameterValue = trimOWS(part.slice(equals + 1));
      parameters[normalizedName] = decodeQuotedString(parameterValue);
    }
    for (var i = 0; i < str.length; i++) {
      var code = str.charCodeAt(i);
      if (quoted) {
        if (escaped) {
          escaped = false;
        } else if (code === 0x5c) {
          escaped = true;
        } else if (code === 0x22) {
          quoted = false;
        }
      } else if (code === 0x22) {
        quoted = true;
      } else if (code === 0x2c || code === 0x3b) {
        parseParameter(i);
        start = i + 1;
      }
    }
    parseParameter(str.length);
    return parameters;
  }
  var isValidHeaderName = function isValidHeaderName(str) {
    return /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
  };

  // `__proto__` is a valid field name, and the one name the uppercase mapping at
  // the bottom of this file cannot reach: it is inherited from Object.prototype
  // instead of being declared on AxiosHeaders.prototype, so `self.__proto__ = v`
  // runs the inherited setter. That silently discards the header, and an array
  // value replaces the instance prototype, taking every method with it.
  // Store it under the same kind of case variant that mapping uses for `set` and
  // `constructor`. Header lookup is caseless, so it reads back under either
  // spelling, and no own `__proto__` slot is ever created for a later
  // `Object.assign` to copy onto a plain object through the same setter.
  var PROTO_HEADER_SLOT = '__Proto__';
  var headerSlot = function headerSlot(name) {
    return name === '__proto__' ? PROTO_HEADER_SLOT : name;
  };
  function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if (utils$1.isFunction(filter)) {
      return filter.call(context, value, header);
    }
    if (isHeaderNameFilter) {
      value = header;
    }
    if (!utils$1.isString(value)) return;
    if (utils$1.isString(filter)) {
      return value.indexOf(filter) !== -1;
    }
    if (utils$1.isRegExp(filter)) {
      return filter.test(value);
    }
  }
  function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function (w, _char, str) {
      return _char.toUpperCase() + str;
    });
  }
  function buildAccessors(obj, header) {
    var accessorName = utils$1.toCamelCase(' ' + header);
    ['get', 'set', 'has'].forEach(function (methodName) {
      Object.defineProperty(obj, methodName + accessorName, {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: function value(arg1, arg2, arg3) {
          return this[methodName].call(this, header, arg1, arg2, arg3);
        },
        configurable: true
      });
    });
  }
  var AxiosHeaders = /*#__PURE__*/function () {
    function AxiosHeaders(headers) {
      _classCallCheck(this, AxiosHeaders);
      headers && this.set(headers);
    }
    return _createClass(AxiosHeaders, [{
      key: "set",
      value: function set(header, valueOrRewrite, rewrite) {
        var self = this;
        function setHeader(_value, _header, _rewrite) {
          var lHeader = normalizeHeader(_header);
          if (!lHeader) {
            return;
          }
          var key = utils$1.findKey(self, lHeader);
          if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) {
            self[headerSlot(key || _header)] = normalizeValue(_value);
          }
        }
        var setHeaders = function setHeaders(headers, _rewrite) {
          return utils$1.forEach(headers, function (_value, _header) {
            return setHeader(_value, _header, _rewrite);
          });
        };
        if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
          setHeaders(header, valueOrRewrite);
        } else if (utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
          setHeaders(parseHeaders(header), valueOrRewrite);
        } else if (utils$1.isObject(header) && utils$1.isSafeIterable(header)) {
          var obj = Object.create(null),
            dest,
            key;
          var _iterator = _createForOfIteratorHelper(header),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var entry = _step.value;
              if (!utils$1.isArray(entry)) {
                throw new TypeError('Object iterator must return a key-value pair');
              }
              key = entry[0];
              if (utils$1.hasOwnProp(obj, key)) {
                dest = obj[key];
                obj[key] = utils$1.isArray(dest) ? [].concat(_toConsumableArray(dest), [entry[1]]) : [dest, entry[1]];
              } else {
                obj[key] = entry[1];
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          setHeaders(obj, valueOrRewrite);
        } else {
          header != null && setHeader(valueOrRewrite, header, rewrite);
        }
        return this;
      }
    }, {
      key: "get",
      value: function get(header, parser) {
        header = normalizeHeader(header);
        if (header) {
          var key = utils$1.findKey(this, header);
          if (key) {
            var value = this[key];
            if (!parser) {
              return value;
            }
            if (parser === true) {
              return parseTokens(value);
            }
            if (utils$1.isFunction(parser)) {
              return parser.call(this, value, key);
            }
            if (utils$1.isRegExp(parser)) {
              return parser.exec(value);
            }
            throw new TypeError('parser must be boolean|regexp|function');
          }
        }
      }
    }, {
      key: "has",
      value: function has(header, matcher) {
        header = normalizeHeader(header);
        if (header) {
          var key = utils$1.findKey(this, header);
          return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
      }
    }, {
      key: "delete",
      value: function _delete(header, matcher) {
        var self = this;
        var deleted = false;
        function deleteHeader(_header) {
          _header = normalizeHeader(_header);
          if (_header) {
            var key = utils$1.findKey(self, _header);
            if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
              delete self[key];
              deleted = true;
            }
          }
        }
        if (utils$1.isArray(header)) {
          header.forEach(deleteHeader);
        } else {
          deleteHeader(header);
        }
        return deleted;
      }
    }, {
      key: "clear",
      value: function clear(matcher) {
        var keys = Object.keys(this);
        var i = keys.length;
        var deleted = false;
        while (i--) {
          var key = keys[i];
          if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
            delete this[key];
            deleted = true;
          }
        }
        return deleted;
      }
    }, {
      key: "normalize",
      value: function normalize(format) {
        var self = this;
        var headers = Object.create(null);
        utils$1.forEach(this, function (value, header) {
          var key = utils$1.findKey(headers, header);
          if (key) {
            self[key] = normalizeValue(value);
            delete self[header];
            return;
          }
          var normalized = headerSlot(format ? formatHeader(header) : String(header).trim());
          if (normalized !== header) {
            delete self[header];
          }
          self[normalized] = normalizeValue(value);
          headers[normalized] = true;
        });
        return this;
      }
    }, {
      key: "concat",
      value: function concat() {
        var _this$constructor;
        for (var _len = arguments.length, targets = new Array(_len), _key = 0; _key < _len; _key++) {
          targets[_key] = arguments[_key];
        }
        return (_this$constructor = this.constructor).concat.apply(_this$constructor, [this].concat(targets));
      }
    }, {
      key: "toJSON",
      value: function toJSON(asStrings) {
        var obj = Object.create(null);
        utils$1.forEach(this, function (value, header) {
          value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(', ') : value);
        });
        return obj;
      }
    }, {
      key: Symbol.iterator,
      value: function value() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
      }
    }, {
      key: "toString",
      value: function toString() {
        return Object.entries(this.toJSON()).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            header = _ref2[0],
            value = _ref2[1];
          return header + ': ' + value;
        }).join('\n');
      }
    }, {
      key: "getSetCookie",
      value: function getSetCookie() {
        var value = this.get('set-cookie');
        return utils$1.isArray(value) ? value : value == null || value === false ? [] : [value];
      }
    }, {
      key: Symbol.toStringTag,
      get: function get() {
        return 'AxiosHeaders';
      }
    }], [{
      key: "from",
      value: function from(thing) {
        return thing instanceof this ? thing : new this(thing);
      }
    }, {
      key: "parseParameters",
      value: function parseParameters(value) {
        return _parseParameters(value);
      }
    }, {
      key: "concat",
      value: function concat(first) {
        var computed = new this(first);
        for (var _len2 = arguments.length, targets = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          targets[_key2 - 1] = arguments[_key2];
        }
        targets.forEach(function (target) {
          return computed.set(target);
        });
        return computed;
      }
    }, {
      key: "accessor",
      value: function accessor(header) {
        var internals = this[$internals$1] = this[$internals$1] = {
          accessors: {}
        };
        var accessors = internals.accessors;
        var prototype = this.prototype;
        function defineAccessor(_header) {
          var lHeader = normalizeHeader(_header);
          if (!accessors[lHeader]) {
            buildAccessors(prototype, _header);
            accessors[lHeader] = true;
          }
        }
        utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
      }
    }]);
  }();
  AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

  // reserved names hotfix
  utils$1.reduceDescriptors(AxiosHeaders.prototype, function (_ref3, key) {
    var value = _ref3.value;
    var mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
      get: function get() {
        return value;
      },
      set: function set(headerValue) {
        this[mapped] = headerValue;
      }
    };
  });
  utils$1.freezeMethods(AxiosHeaders);

  var REDACTED = '[REDACTED ****]';
  function hasOwnOrPrototypeToJSON(source) {
    if (utils$1.hasOwnProp(source, 'toJSON')) {
      return true;
    }
    var prototype = Object.getPrototypeOf(source);
    while (prototype && prototype !== Object.prototype) {
      if (utils$1.hasOwnProp(prototype, 'toJSON')) {
        return true;
      }
      prototype = Object.getPrototypeOf(prototype);
    }
    return false;
  }

  // Build a plain-object snapshot of `config` and replace the value of any key
  // (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
  // and AxiosHeaders, and short-circuits on circular references.
  function redactConfig(config, redactKeys) {
    var lowerKeys = new Set(redactKeys.map(function (k) {
      return String(k).toLowerCase();
    }));
    var seen = [];
    var _visit = function visit(source) {
      if (source === null || _typeof(source) !== 'object') return source;
      if (utils$1.isBuffer(source)) return source;
      if (seen.indexOf(source) !== -1) return undefined;
      if (source instanceof AxiosHeaders) {
        source = source.toJSON();
      }
      seen.push(source);
      var result;
      if (utils$1.isArray(source)) {
        result = [];
        source.forEach(function (v, i) {
          var reducedValue = _visit(v);
          if (!utils$1.isUndefined(reducedValue)) {
            result[i] = reducedValue;
          }
        });
      } else {
        if (!utils$1.isPlainObject(source) && hasOwnOrPrototypeToJSON(source)) {
          seen.pop();
          return source;
        }
        result = Object.create(null);
        for (var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];
          var reducedValue = lowerKeys.has(key.toLowerCase()) ? REDACTED : _visit(value);
          if (!utils$1.isUndefined(reducedValue)) {
            result[key] = reducedValue;
          }
        }
      }
      seen.pop();
      return result;
    };
    return _visit(config);
  }
  function stringifySafely$1(value) {
    try {
      return String(value);
    } catch (err) {
      return '';
    }
  }
  function aggregateErrorMessage(error) {
    var message = error.errors.map(function (entry) {
      try {
        return entry && entry.message ? stringifySafely$1(entry.message) : stringifySafely$1(entry);
      } catch (err) {
        return '';
      }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
  }

  // Shared with `Axios.prototype.request`, which splices the reconstructed
  // caller frames in ahead of this marker.
  var CAUSED_BY_SEPARATOR = '\nCaused by: ';
  var $causeStack = Symbol('causeStack');

  // Match the section we appended, not marker-like text in an error message or
  // a replacement stack supplied by the caller. Do not re-read the cause's stack.
  function getCauseStackIndex(error, stack) {
    var causeStack = utils$1.hasOwnProp(error, $causeStack) && error[$causeStack];
    return causeStack && stack.endsWith(causeStack) ? stack.length - causeStack.length : -1;
  }

  /**
   * Append the stack of a wrapped error to `target.stack`.
   *
   * `cause` already exposes the original error for tooling that walks the standard
   * cause chain, but many error reporters read `stack` and nothing else. Inlining
   * the wrapped stack there means those reporters surface the underlying failure
   * instead of the axios frames that normalized it (see #6670).
   *
   * Every read is defensive: a custom `Error.prepareStackTrace` hook, a runtime
   * without stack support, or a replaced `stack` property can leave the value
   * missing, non-string, or read-only, and normalizing an error must not throw
   * because of that.
   *
   * @param {Error} target The AxiosError being built.
   * @param {Error} source The error being wrapped.
   *
   * @returns {void}
   */
  function appendCauseStack(target, source) {
    try {
      var sourceStack = source && source.stack;
      if (typeof sourceStack !== 'string' || !sourceStack) {
        return;
      }
      var targetStack = target.stack;
      if (typeof targetStack !== 'string' || !targetStack) {
        return;
      }

      // Each call to `from()` creates a fresh target. Re-wrapping includes the
      // previous stack verbatim, adding one cause section per wrap.
      var causeStack = CAUSED_BY_SEPARATOR + sourceStack;
      target.stack = targetStack + causeStack;
      Object.defineProperty(target, $causeStack, {
        __proto__: null,
        value: causeStack
      });
    } catch (e) {
      // Ignore failures from custom stack hooks or un-writable stack properties.
    }
  }
  var AxiosError = /*#__PURE__*/function (_Error) {
    /**
     * Create an Error with the specified message, config, error code, request and response.
     *
     * @param {string} message The error message.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [config] The config.
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     *
     * @returns {Error} The created error.
     */
    function AxiosError(message, code, config, request, response) {
      var _this;
      _classCallCheck(this, AxiosError);
      _this = _callSuper(this, AxiosError, [message]);

      // Make message enumerable to maintain backward compatibility
      // The native Error constructor sets message as non-enumerable,
      // but axios < v1.13.3 had it as enumerable
      Object.defineProperty(_this, 'message', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: message,
        enumerable: true,
        writable: true,
        configurable: true
      });
      _this.name = 'AxiosError';
      _this.isAxiosError = true;
      code && (_this.code = code);
      config && (_this.config = config);
      request && (_this.request = request);
      if (response) {
        _this.response = response;
        _this.status = response.status;
      }
      return _this;
    }
    _inherits(AxiosError, _Error);
    return _createClass(AxiosError, [{
      key: "toJSON",
      value: function toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        var config = this.config;
        var redactKeys = config && utils$1.hasOwnProp(config, 'redact') ? config.redact : undefined;
        var serializedConfig = utils$1.isArray(redactKeys) && redactKeys.length > 0 ? redactConfig(config, redactKeys) : utils$1.toJSONObject(config);
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: serializedConfig,
          code: this.code,
          status: this.status
        };
      }
    }], [{
      key: "from",
      value: function from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        var message = error.message;
        if (!message && utils$1.isArray(error.errors) && error.errors.length) {
          message = aggregateErrorMessage(error);
        }
        var axiosError = new AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
          __proto__: null,
          value: error,
          writable: true,
          enumerable: false,
          configurable: true
        });
        axiosError.name = error.name;

        // Inline the wrapped stack for reporters that read only `stack`; the `cause`
        // property above already covers cause-aware tooling.
        appendCauseStack(axiosError, error);

        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) {
          axiosError.status = error.status;
        }
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(Error)); // This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
  AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
  AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
  AxiosError.ECONNABORTED = 'ECONNABORTED';
  AxiosError.ETIMEDOUT = 'ETIMEDOUT';
  AxiosError.ECONNREFUSED = 'ECONNREFUSED';
  AxiosError.ERR_NETWORK = 'ERR_NETWORK';
  AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
  AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
  AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
  AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
  AxiosError.ERR_CANCELED = 'ERR_CANCELED';
  AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
  AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
  AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';

  // eslint-disable-next-line strict
  var httpAdapter = null;

  // Default nesting limit shared with the inverse transform (formDataToJSON) so
  // the FormData <-> JSON round-trip stays symmetric.
  var DEFAULT_FORM_DATA_MAX_DEPTH = 100;

  /**
   * Determines if the given thing is a array or js object.
   *
   * @param {string} thing - The object or array to be visited.
   *
   * @returns {boolean}
   */
  function isVisitable(thing) {
    return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
  }

  /**
   * It removes the brackets from the end of a string
   *
   * @param {string} key - The key of the parameter.
   *
   * @returns {string} the key without the brackets.
   */
  function removeBrackets(key) {
    return utils$1.endsWith(key, '[]') ? key.slice(0, -2) : key;
  }

  /**
   * It takes a path, a key, and a boolean, and returns a string
   *
   * @param {string} path - The path to the current key.
   * @param {string} key - The key of the current object being iterated over.
   * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
   *
   * @returns {string} The path to the current key.
   */
  function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
      // eslint-disable-next-line no-param-reassign
      token = removeBrackets(token);
      return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
  }

  /**
   * If the array is an array and none of its elements are visitable, then it's a flat array.
   *
   * @param {Array<any>} arr - The array to check
   *
   * @returns {boolean}
   */
  function isFlatArray(arr) {
    return utils$1.isArray(arr) && !arr.some(isVisitable);
  }
  var predicates = utils$1.toFlatObject(utils$1, {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
  });

  /**
   * Convert a data object to FormData
   *
   * @param {Object} obj
   * @param {?Object} [formData]
   * @param {?Object} [options]
   * @param {Function} [options.visitor]
   * @param {Boolean} [options.metaTokens = true]
   * @param {Boolean} [options.dots = false]
   * @param {?Boolean} [options.indexes = false]
   *
   * @returns {Object}
   **/

  /**
   * It converts an object into a FormData object
   *
   * @param {Object<any, any>} obj - The object to convert to form data.
   * @param {string} formData - The FormData object to append to.
   * @param {Object<string, any>} options
   *
   * @returns
   */
  function toFormData(obj, formData, options) {
    if (!utils$1.isObject(obj)) {
      throw new TypeError('target must be an object');
    }

    // eslint-disable-next-line no-param-reassign
    formData = formData || new (FormData)();
    var option = function option(name, fallback) {
      var value = utils$1.getSafeProp(options, name);
      return utils$1.isUndefined(value) ? fallback : value;
    };
    var metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    var visitor = option('visitor') || defaultVisitor;
    var dots = option('dots', false);
    var indexes = option('indexes', false);
    var _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    var maxDepth = option('maxDepth', DEFAULT_FORM_DATA_MAX_DEPTH);
    var useBlob = _Blob && utils$1.isSpecCompliantForm(formData);
    var stack = [];
    if (!utils$1.isFunction(visitor)) {
      throw new TypeError('visitor must be a function');
    }
    function convertValue(value) {
      if (value === null) return '';
      if (utils$1.isDate(value)) {
        return value.toISOString();
      }
      if (utils$1.isBoolean(value)) {
        return value.toString();
      }
      if (!useBlob && utils$1.isBlob(value)) {
        throw new AxiosError('Blob is not supported. Use a Buffer instead.');
      }
      if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
        if (useBlob && typeof _Blob === 'function') {
          return new _Blob([value]);
        }
        throw new AxiosError('Blob is not supported. Use a Buffer instead.', AxiosError.ERR_NOT_SUPPORT);
      }
      return value;
    }
    function throwIfMaxDepthExceeded(depth) {
      if (depth > maxDepth) {
        throw new AxiosError('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED);
      }
    }
    function stringifyWithDepthLimit(value, depth) {
      if (maxDepth === Infinity) {
        return JSON.stringify(value);
      }
      var ancestors = [];
      return JSON.stringify(value, function limitDepth(_key, currentValue) {
        if (!utils$1.isObject(currentValue)) {
          return currentValue;
        }
        while (ancestors.length && ancestors[ancestors.length - 1] !== this) {
          ancestors.pop();
        }
        ancestors.push(currentValue);
        throwIfMaxDepthExceeded(depth + ancestors.length - 1);
        return currentValue;
      });
    }

    /**
     * Default visitor.
     *
     * @param {*} value
     * @param {String|Number} key
     * @param {Array<String|Number>} path
     * @this {FormData}
     *
     * @returns {boolean} return true to visit the each prop of the value recursively
     */
    function defaultVisitor(value, key, path) {
      var arr = value;
      if (utils$1.isReactNative(formData) && utils$1.isReactNativeBlob(value)) {
        formData.append(renderKey(path, key, dots), convertValue(value));
        return false;
      }
      if (value && !path && _typeof(value) === 'object') {
        if (utils$1.endsWith(key, '{}')) {
          // eslint-disable-next-line no-param-reassign
          key = metaTokens ? key : key.slice(0, -2);
          // eslint-disable-next-line no-param-reassign
          value = stringifyWithDepthLimit(value, 1);
        } else if (utils$1.isArray(value) && isFlatArray(value) || (utils$1.isFileList(value) || utils$1.endsWith(key, '[]')) && (arr = utils$1.toArray(value))) {
          // eslint-disable-next-line no-param-reassign
          key = removeBrackets(key);
          arr.forEach(function each(el, index) {
            !(utils$1.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
          });
          return false;
        }
      }
      if (isVisitable(value)) {
        return true;
      }
      formData.append(renderKey(path, key, dots), convertValue(value));
      return false;
    }
    var exposedHelpers = Object.assign(predicates, {
      defaultVisitor: defaultVisitor,
      convertValue: convertValue,
      isVisitable: isVisitable
    });
    function build(value, path) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      if (utils$1.isUndefined(value)) return;
      throwIfMaxDepthExceeded(depth);
      if (stack.indexOf(value) !== -1) {
        throw new Error('Circular reference detected in ' + path.join('.'));
      }
      stack.push(value);
      utils$1.forEach(value, function each(el, key) {
        var result = !(utils$1.isUndefined(el) || el === null) && visitor.call(formData, el, utils$1.isString(key) ? key.trim() : key, path, exposedHelpers);
        if (result === true) {
          build(el, path ? path.concat(key) : [key], depth + 1);
        }
      });
      stack.pop();
    }
    if (!utils$1.isObject(obj)) {
      throw new TypeError('data must be an object');
    }
    build(obj);
    return formData;
  }

  /**
   * It encodes a string by replacing all characters that are not in the unreserved set with
   * their percent-encoded equivalents
   *
   * @param {string} str - The string to encode.
   *
   * @returns {string} The encoded string.
   */
  function encode$1(str) {
    var charMap = {
      '!': '%21',
      "'": '%27',
      '(': '%28',
      ')': '%29',
      '~': '%7E',
      '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
      return charMap[match];
    });
  }

  /**
   * It takes a params object and converts it to a FormData object
   *
   * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
   * @param {Object<string, any>} options - The options object passed to the Axios constructor.
   *
   * @returns {void}
   */
  function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && toFormData(params, this, options);
  }
  var prototype = AxiosURLSearchParams.prototype;
  prototype.append = function append(name, value) {
    this._pairs.push([name, value]);
  };
  prototype.toString = function toString(encoder) {
    var _this = this;
    var _encode = encoder ? function (value) {
      return encoder.call(_this, value, encode$1);
    } : encode$1;
    return this._pairs.map(function each(pair) {
      return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
  };

  /**
   * It replaces URL-encoded forms of `:`, `$`, `,`, and spaces with
   * their plain counterparts (`:`, `$`, `,`, `+`).
   *
   * @param {string} val The value to be encoded.
   *
   * @returns {string} The encoded value.
   */
  function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
  }

  /**
   * Build a URL by appending params to the end
   *
   * @param {string} url The base of the url (e.g., http://www.google.com)
   * @param {object} [params] The params to be appended
   * @param {?(object|Function)} options
   *
   * @returns {string} The formatted url
   */
  function buildURL(url, params, options) {
    if (!params) {
      return url;
    }
    url = url || '';
    var _options = utils$1.isFunction(options) ? {
      serialize: options
    } : options;

    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    var _encode = utils$1.getSafeProp(_options, 'encode') || encode;
    var serializeFn = utils$1.getSafeProp(_options, 'serialize');
    var serializedParams;
    if (serializeFn) {
      serializedParams = serializeFn(params, _options);
    } else {
      serializedParams = utils$1.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams(params, _options).toString(_encode);
    }
    if (serializedParams) {
      var hashmarkIndex = url.indexOf('#');
      if (hashmarkIndex !== -1) {
        url = url.slice(0, hashmarkIndex);
      }
      url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
  }

  var $internals = Symbol('internals');

  // `handlers` is public and may be replaced with a nullish value by user code;
  // `clear()` has always tolerated that. Treat it as an empty stack rather than
  // dereferencing it.
  function countHandlers(handlers) {
    return handlers ? handlers.length : 0;
  }
  function trimHandlers(handlers) {
    if (!handlers) {
      return;
    }
    while (handlers.length && handlers[handlers.length - 1] === null) {
      handlers.pop();
    }
  }

  // Preserve the array-key coercion used before IDs were stored in a Map, without
  // treating null, empty strings, or noncanonical numeric strings as ID zero.
  function normalizeHandlerId(id) {
    if (typeof id === 'string' && id !== '' && String(Number(id)) === id) {
      return Number(id);
    }
    return id;
  }
  function syncHandlerEntries(manager, internals) {
    var handlers = manager.handlers;
    var length = countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
      internals.handlersRef = handlers;
      internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
      if (!length) {
        internals.handlerEntries.clear();
      } else {
        internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
          if (handlers[entry.index] !== entry.handler) {
            internals.handlerEntries["delete"](id);
          }
        });
      }
    }
    internals.handlersLength = length;
  }
  var InterceptorManager = /*#__PURE__*/function () {
    function InterceptorManager() {
      _classCallCheck(this, InterceptorManager);
      this.handlers = [];
      this[$internals] = {
        handlersRef: this.handlers,
        handlersLength: this.handlers.length,
        handlerEntries: new Map(),
        iterationDepth: 0,
        nextId: 0
      };
    }

    /**
     * Add a new interceptor to the stack
     *
     * @param {Function} fulfilled The function to handle `then` for a `Promise`
     * @param {Function} rejected The function to handle `reject` for a `Promise`
     * @param {Object} options The options for the interceptor, synchronous and runWhen
     *
     * @return {Number} An ID used to remove interceptor later
     */
    return _createClass(InterceptorManager, [{
      key: "use",
      value: function use(fulfilled, rejected, options) {
        var handler = {
          fulfilled: fulfilled,
          rejected: rejected,
          synchronous: options ? options.synchronous : false,
          runWhen: options ? options.runWhen : null
        };
        var internals = this[$internals];
        if (this.handlers == null) {
          this.handlers = [];
        }
        syncHandlerEntries(this, internals);
        var id = internals.nextId++;
        this.handlers.push(handler);
        internals.handlerEntries.set(id, {
          handler: handler,
          index: this.handlers.length - 1
        });
        internals.handlersLength = this.handlers.length;
        return id;
      }

      /**
       * Remove an interceptor from the stack
       *
       * @param {Number} id The ID that was returned by `use`
       *
       * @returns {void}
       */
    }, {
      key: "eject",
      value: function eject(id) {
        var internals = this[$internals];
        syncHandlerEntries(this, internals);
        var handlerId = normalizeHandlerId(id);
        var entry = internals.handlerEntries.get(handlerId);
        if (entry) {
          internals.handlerEntries["delete"](handlerId);

          // Ignore IDs invalidated by clear or direct replacement of handlers.
          if (this.handlers[entry.index] !== entry.handler) {
            return;
          }
          this.handlers[entry.index] = null;

          // Do not reuse an index while forEach is walking its length snapshot.
          if (!internals.iterationDepth) {
            trimHandlers(this.handlers);
            internals.handlersLength = this.handlers.length;
          }
        }
      }

      /**
       * Clear all interceptors from the stack
       *
       * @returns {void}
       */
    }, {
      key: "clear",
      value: function clear() {
        if (this.handlers) {
          this.handlers = [];
          syncHandlerEntries(this, this[$internals]);
        }
      }

      /**
       * Iterate over all the registered interceptors
       *
       * This method is particularly useful for skipping over any
       * interceptors that may have become `null` calling `eject`.
       *
       * @param {Function} fn The function to call for each interceptor
       *
       * @returns {void}
       */
    }, {
      key: "forEach",
      value: function forEach(fn) {
        var internals = this[$internals];
        syncHandlerEntries(this, internals);
        internals.iterationDepth++;
        try {
          utils$1.forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) {
              fn(h);
            }
          });
        } finally {
          if (! --internals.iterationDepth) {
            syncHandlerEntries(this, internals);
            trimHandlers(this.handlers);
            internals.handlersLength = countHandlers(this.handlers);
          }
        }
      }
    }]);
  }();

  var transitionalDefaults = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true,
    encodeBasicAuthUsername: false
  };

  var URLSearchParams$1 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;

  var FormData$1 = typeof FormData !== 'undefined' ? FormData : null;

  var Blob$1 = typeof Blob !== 'undefined' ? Blob : null;

  var platform$1 = {
    isBrowser: true,
    classes: {
      URLSearchParams: URLSearchParams$1,
      FormData: FormData$1,
      Blob: Blob$1
    },
    protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
  };

  var hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';
  var _navigator = (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) === 'object' && navigator || undefined;

  /**
   * Determine if we're running in a standard browser environment
   *
   * This allows axios to run in a web worker, and react-native.
   * Both environments support XMLHttpRequest, but not fully standard globals.
   *
   * web workers:
   *  typeof window -> undefined
   *  typeof document -> undefined
   *
   * react-native:
   *  navigator.product -> 'ReactNative'
   * nativescript
   *  navigator.product -> 'NativeScript' or 'NS'
   *
   * @returns {boolean}
   */
  var hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || ['ReactNative', 'NativeScript', 'NS'].indexOf(_navigator.product) < 0);

  /**
   * Determine if we're running in a standard browser webWorker environment
   *
   * Although the `isStandardBrowserEnv` method indicates that
   * `allows axios to run in a web worker`, the WebWorker will still be
   * filtered out due to its judgment standard
   * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
   * This leads to a problem when axios post `FormData` in webWorker
   */
  var hasStandardBrowserWebWorkerEnv = function () {
    return typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
  }();
  var origin = hasBrowserEnv && window.location.href || 'http://localhost';

  var utils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    hasBrowserEnv: hasBrowserEnv,
    hasStandardBrowserEnv: hasStandardBrowserEnv,
    hasStandardBrowserWebWorkerEnv: hasStandardBrowserWebWorkerEnv,
    navigator: _navigator,
    origin: origin
  });

  var platform = _objectSpread2(_objectSpread2({}, utils), platform$1);

  function toURLEncodedForm(data, options) {
    return toFormData(data, new platform.classes.URLSearchParams(), _objectSpread2({
      visitor: function visitor(value, key, path, helpers) {
        if (platform.isNode && utils$1.isBuffer(value)) {
          this.append(key, value.toString('base64'));
          return false;
        }
        return helpers.defaultVisitor.apply(this, arguments);
      }
    }, options));
  }

  var MAX_DEPTH = DEFAULT_FORM_DATA_MAX_DEPTH;
  function throwIfDepthExceeded(index) {
    if (index > MAX_DEPTH) {
      throw new AxiosError('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + MAX_DEPTH, AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
  }

  /**
   * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
   *
   * @param {string} name - The name of the property to get.
   *
   * @returns An array of strings.
   */
  function parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    var path = [];
    var pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    var match;
    while ((match = pattern.exec(name)) !== null) {
      throwIfDepthExceeded(path.length);
      path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
  }

  /**
   * Convert an array to an object.
   *
   * @param {Array<any>} arr - The array to convert to an object.
   *
   * @returns An object with the same keys and values as the array.
   */
  function arrayToObject(arr) {
    var obj = {};
    var keys = Object.keys(arr);
    var i;
    var len = keys.length;
    var key;
    for (i = 0; i < len; i++) {
      key = keys[i];
      obj[key] = arr[key];
    }
    return obj;
  }
  function normalizeArray(value) {
    if (!utils$1.isArray(value)) return value;
    var keys = Object.keys(value);
    return keys.length !== value.length || keys.some(function (key, index) {
      return key !== String(index);
    }) ? arrayToObject(value) : value;
  }
  function normalizeArrays(obj) {
    var pending = [obj];
    var _loop = function _loop() {
      var target = pending.pop();
      Object.keys(target).forEach(function (key) {
        var value = target[key] = normalizeArray(target[key]);
        if (utils$1.isArray(value) || utils$1.isPlainObject(value)) {
          pending.push(value);
        }
      });
    };
    while (pending.length) {
      _loop();
    }
    return obj;
  }

  /**
   * It takes a FormData object and returns a JavaScript object
   *
   * @param {string} formData The FormData object to convert to JSON.
   *
   * @returns {Object<string, any> | null} The converted object.
   */
  function formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
      throwIfDepthExceeded(index);
      var name = path[index++];
      if (name === '__proto__') return true;
      var isNumericKey = Number.isFinite(+name);
      var isLast = index >= path.length;
      name = !name && utils$1.isArray(target) ? target.length : name;
      if (isLast) {
        if (utils$1.hasOwnProp(target, name)) {
          target[name] = normalizeArray(target[name]);
          target[name] = utils$1.isArray(target[name]) ? target[name].concat(value) : [target[name], value];
        } else {
          target[name] = value;
        }
        return !isNumericKey;
      }
      if (!utils$1.hasOwnProp(target, name) || !utils$1.isObject(target[name])) {
        target[name] = [];
      }
      var result = buildPath(path, value, target[name], index);
      if (result && utils$1.isArray(target[name])) {
        target[name] = arrayToObject(target[name]);
      }
      return !isNumericKey;
    }
    if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
      var obj = {};
      utils$1.forEachEntry(formData, function (name, value) {
        buildPath(parsePropPath(name), value, obj, 0);
      });
      return normalizeArrays(obj);
    }
    return null;
  }

  var methodList = Object.freeze(['get', 'delete', 'head', 'options', 'post', 'put', 'patch', 'purge', 'link', 'unlink', 'query']);

  var own = function own(obj, key) {
    return obj != null && utils$1.hasOwnProp(obj, key) ? obj[key] : undefined;
  };

  /**
   * It takes a string, tries to parse it, and if it fails, it returns the stringified version
   * of the input
   *
   * @param {any} rawValue - The value to be stringified.
   * @param {Function} parser - A function that parses a string into a JavaScript object.
   * @param {Function} encoder - A function that takes a value and returns a string.
   *
   * @returns {string} A stringified version of the rawValue.
   */
  function stringifySafely(rawValue, parser, encoder) {
    if (utils$1.isString(rawValue)) {
      try {
        (parser || JSON.parse)(rawValue);
        return utils$1.trim(rawValue);
      } catch (e) {
        if (e.name !== 'SyntaxError') {
          throw e;
        }
      }
    }
    return (encoder || JSON.stringify)(rawValue);
  }
  var defaults = {
    transitional: transitionalDefaults,
    adapter: ['xhr', 'http', 'fetch'],
    transformRequest: [function transformRequest(data, headers) {
      var contentType = headers.getContentType() || '';
      var hasJSONContentType = contentType.indexOf('application/json') > -1;
      var isObjectPayload = utils$1.isObject(data);
      if (isObjectPayload && utils$1.isHTMLForm(data)) {
        data = new FormData(data);
      }
      var isFormData = utils$1.isFormData(data);
      if (isFormData) {
        return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
      }
      if (utils$1.isArrayBuffer(data) || utils$1.isBuffer(data) || utils$1.isStream(data) || utils$1.isFile(data) || utils$1.isBlob(data) || utils$1.isReadableStream(data)) {
        return data;
      }
      if (utils$1.isArrayBufferView(data)) {
        return data.buffer;
      }
      if (utils$1.isURLSearchParams(data)) {
        headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
        return data.toString();
      }
      var isFileList;
      if (isObjectPayload) {
        var formSerializer = own(this, 'formSerializer');
        if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
          return toURLEncodedForm(data, formSerializer).toString();
        }
        if ((isFileList = utils$1.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
          var env = own(this, 'env');
          var _FormData = env && env.FormData;
          return toFormData(isFileList ? {
            'files[]': data
          } : data, _FormData && new _FormData(), formSerializer);
        }
      }
      if (isObjectPayload || hasJSONContentType) {
        headers.setContentType('application/json', false);
        return stringifySafely(data);
      }
      return data;
    }],
    transformResponse: [function transformResponse(data) {
      var transitional = own(this, 'transitional') || defaults.transitional;
      var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
      var responseType = own(this, 'responseType');
      var JSONRequested = responseType === 'json';
      if (utils$1.isResponse(data) || utils$1.isReadableStream(data)) {
        return data;
      }
      if (data && utils$1.isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
        var silentJSONParsing = transitional && transitional.silentJSONParsing;
        var strictJSONParsing = !silentJSONParsing && JSONRequested;
        try {
          return JSON.parse(data, own(this, 'parseReviver'));
        } catch (e) {
          if (strictJSONParsing) {
            if (e.name === 'SyntaxError') {
              throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, own(this, 'response'));
            }
            throw e;
          }
        }
      }
      return data;
    }],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
      FormData: platform.classes.FormData,
      Blob: platform.classes.Blob
    },
    validateStatus: function validateStatus(status) {
      return status >= 200 && status < 300;
    },
    headers: {
      common: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': undefined
      }
    }
  };
  utils$1.forEach(methodList, function (method) {
    defaults.headers[method] = {};
  });

  /**
   * Transform the data for a request or a response
   *
   * @param {Array|Function} fns A single function or Array of functions
   * @param {?Object} response The response object
   *
   * @returns {*} The resulting transformed data
   */
  function transformData(fns, response) {
    var config = this || defaults;
    var context = response || config;
    var headers = AxiosHeaders.from(context.headers);
    var data = context.data;
    utils$1.forEach(fns, function transform(fn) {
      data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
  }

  function isCancel(value) {
    return !!(value && value.__CANCEL__);
  }

  var CanceledError = /*#__PURE__*/function (_AxiosError) {
    /**
     * A `CanceledError` is an object that is thrown when an operation is canceled.
     *
     * @param {string=} message The message.
     * @param {Object=} config The config.
     * @param {Object=} request The request.
     *
     * @returns {CanceledError} The created error.
     */
    function CanceledError(message, config, request) {
      var _this;
      _classCallCheck(this, CanceledError);
      _this = _callSuper(this, CanceledError, [message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request]);
      _this.name = 'CanceledError';
      _this.__CANCEL__ = true;
      return _this;
    }
    _inherits(CanceledError, _AxiosError);
    return _createClass(CanceledError);
  }(AxiosError);

  /**
   * Resolve or reject a Promise based on response status.
   *
   * @param {Function} resolve A function that resolves the promise.
   * @param {Function} reject A function that rejects the promise.
   * @param {object} response The response.
   *
   * @returns {object} The response.
   */
  function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) {
      resolve(response);
    } else {
      reject(new AxiosError('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? AxiosError.ERR_BAD_REQUEST : AxiosError.ERR_BAD_RESPONSE, response.config, response.request, response));
    }
  }

  var urlParserControlCharacters = /[\t\n\r]/g;

  /**
   * Match WHATWG URL preprocessing before checking a URL's protocol.
   *
   * @param {string} url
   *
   * @returns {string}
   */
  function normalizeURLForProtocolCheck(url) {
    if (typeof url !== 'string') {
      return url;
    }
    var start = 0;
    while (start < url.length && url.charCodeAt(start) <= 0x20) {
      start++;
    }
    return url.slice(start).replace(urlParserControlCharacters, '');
  }

  function parseProtocol(url) {
    var match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1].toLowerCase() || '';
  }

  var decodeCookieValue = function decodeCookieValue(value) {
    try {
      return decodeURIComponent(value);
    } catch (e) {
      return value;
    }
  };
  var cookies = platform.hasStandardBrowserEnv ?
  // Standard browser envs support document.cookie
  {
    write: function write(name, value, expires, path, domain, secure, sameSite) {
      if (typeof document === 'undefined') return;
      var cookie = ["".concat(name, "=").concat(encodeURIComponent(value))];
      if (utils$1.isNumber(expires)) {
        cookie.push("expires=".concat(new Date(expires).toUTCString()));
      }
      if (utils$1.isString(path)) {
        cookie.push("path=".concat(path));
      }
      if (utils$1.isString(domain)) {
        cookie.push("domain=".concat(domain));
      }
      if (secure === true) {
        cookie.push('secure');
      }
      if (utils$1.isString(sameSite)) {
        cookie.push("SameSite=".concat(sameSite));
      }
      document.cookie = cookie.join('; ');
    },
    read: function read(name) {
      if (typeof document === 'undefined') return null;
      var cookieString = document.cookie;
      if (!cookieString) return null;
      // Match name=value by splitting on the semicolon separator instead of building a
      // RegExp from `name` — interpolating an unescaped string into a RegExp would let
      // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
      // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
      // "; ", so ignore optional whitespace before each cookie name.
      var cookies = cookieString.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].replace(/^\s+/, '');
        var eq = cookie.indexOf('=');
        if (eq !== -1 && cookie.slice(0, eq) === name) {
          return decodeCookieValue(cookie.slice(eq + 1));
        }
      }
      return null;
    },
    readAsync: function readAsync(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var store, cookie;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              store = typeof window !== 'undefined' && window.cookieStore;
              if (!(store && utils$1.isFunction(store.get))) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return store.get(name);
            case 1:
              cookie = _context.v;
              return _context.a(2, cookie ? decodeCookieValue(cookie.value) : null);
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _context.v;
            case 4:
              return _context.a(2, _this.read(name));
          }
        }, _callee, null, [[0, 3]]);
      }))();
    },
    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000, '/');
    }
  } :
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write: function write() {},
    read: function read() {
      return null;
    },
    readAsync: function readAsync() {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, null);
          }
        }, _callee2);
      }))();
    },
    remove: function remove() {}
  };

  /**
   * Calculate data maxRate
   * @param {Number} [samplesCount= 10]
   * @param {Number} [min= 1000]
   * @returns {Function}
   */
  function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    var bytes = new Array(samplesCount);
    var timestamps = new Array(samplesCount);
    var head = 0;
    var tail = 0;
    var firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
      var now = Date.now();
      var startedAt = timestamps[tail];
      if (!firstSampleTS) {
        firstSampleTS = now;
      }
      bytes[head] = chunkLength;
      timestamps[head] = now;
      var i = tail;
      var bytesCount = 0;
      while (i !== head) {
        bytesCount += bytes[i++];
        i = i % samplesCount;
      }
      head = (head + 1) % samplesCount;
      if (head === tail) {
        tail = (tail + 1) % samplesCount;
      }
      if (now - firstSampleTS < min) {
        return;
      }
      var passed = startedAt && now - startedAt;
      return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
  }

  /**
   * Throttle decorator
   * @param {Function} fn
   * @param {Number} freq
   * @return {Array<Function>}
   */
  function throttle(fn, freq) {
    var timestamp = 0;
    var threshold = 1000 / freq;
    var lastArgs;
    var timer;
    var invoke = function invoke(args) {
      var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
      timestamp = now;
      lastArgs = null;
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      fn.apply(void 0, _toConsumableArray(args));
    };
    var throttled = function throttled() {
      var now = Date.now();
      var passed = now - timestamp;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (passed >= threshold) {
        invoke(args, now);
      } else {
        lastArgs = args;
        if (!timer) {
          timer = setTimeout(function () {
            timer = null;
            invoke(lastArgs);
          }, threshold - passed);
        }
      }
    };
    var flush = function flush() {
      return lastArgs && invoke(lastArgs);
    };
    var flushWith = function flushWith() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return invoke(args);
    };
    return [throttled, flush, flushWith];
  }

  var progressEventReducer = function progressEventReducer(listener, isDownloadStream) {
    var freq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
    var bytesNotified = 0;
    var _speedometer = speedometer(50, 250);
    return throttle(function (e) {
      if (!e || !utils$1.isNumber(e.loaded)) {
        return;
      }
      var rawLoaded = e.loaded;
      var total = e.lengthComputable ? e.total : undefined;
      var loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
      var progressBytes = Math.max(0, loaded - bytesNotified);
      var rate = _speedometer(progressBytes);
      bytesNotified = Math.max(bytesNotified, loaded);
      var data = _defineProperty({
        loaded: loaded,
        total: total,
        progress: total ? loaded / total : undefined,
        bytes: progressBytes,
        rate: rate ? rate : undefined,
        estimated: rate && total ? (total - loaded) / rate : undefined,
        event: e,
        lengthComputable: total != null
      }, isDownloadStream ? 'download' : 'upload', true);
      listener(data);
    }, freq);
  };
  var progressEventDecorator = function progressEventDecorator(total, throttled) {
    var lengthComputable = total != null;
    return [function (loaded) {
      return throttled[0]({
        lengthComputable: lengthComputable,
        total: total,
        loaded: loaded
      });
    }, throttled[1]];
  };
  var asyncDecorator = function asyncDecorator(fn) {
    var scheduler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils$1.asap;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return scheduler(function () {
        return fn.apply(void 0, args);
      });
    };
  };

  var isURLSameOrigin = platform.hasStandardBrowserEnv ? function (origin) {
    return function (url) {
      url = new URL(url, document.baseURI || platform.origin);
      return origin.protocol === url.protocol && origin.host === url.host && origin.port === url.port;
    };
  }(new URL(platform.origin)) : function () {
    return true;
  };

  /**
   * Determines whether the specified URL is absolute
   *
   * @param {string} url The URL to test
   *
   * @returns {boolean} True if the specified URL is absolute, otherwise false
   */
  function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') {
      return false;
    }
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
  }

  /**
   * Creates a new URL by combining the specified URLs
   *
   * @param {string} baseURL The base URL
   * @param {string} relativeURL The relative URL
   *
   * @returns {string} The combined URL
   */
  function combineURLs(baseURL, relativeURL) {
    if (!relativeURL) {
      return baseURL;
    }
    var end = baseURL.length;
    while (end > 0 && baseURL.charCodeAt(end - 1) === 47) {
      end--;
    }
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
  }

  var malformedHttpProtocol = /^https?:(?!\/\/)/i;

  // Redact the parts of a URL that can carry secrets before it is embedded in an
  // error message. AxiosError.toJSON() serializes `message` verbatim and errors
  // are commonly logged, while the opt-in `config.redact` model only cleans
  // config keys — it cannot reach the message. Redact only the genuinely
  // sensitive substrings — userinfo (credentials), query parameter values and
  // fragment contents — with the same REDACTED marker the config redaction uses,
  // while keeping the scheme, host, path and parameter names so the offending
  // request stays accurately identifiable.
  function redactFragment(fragment) {
    if (!fragment) {
      return fragment;
    }
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, function (match, separator) {
      var parameterName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      return "".concat(separator).concat(parameterName).concat(REDACTED);
    });
  }
  function redactSensitiveURLParts(url) {
    var redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, "$1".concat(REDACTED, "@"));
    var fragmentIndex = redactedURL.indexOf('#');
    var urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    var redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, "$1".concat(REDACTED));
    if (fragmentIndex === -1) {
      return redactedURLWithoutFragment;
    }
    return "".concat(redactedURLWithoutFragment, "#").concat(redactFragment(redactedURL.slice(fragmentIndex + 1)));
  }
  function assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
      var normalizedURL = normalizeURLForProtocolCheck(url);
      if (malformedHttpProtocol.test(normalizedURL)) {
        throw new AxiosError("Invalid URL ".concat(JSON.stringify(redactSensitiveURLParts(normalizedURL)), ": missing \"//\" after protocol"), AxiosError.ERR_INVALID_URL, config);
      }
    }
  }

  /**
   * Creates a new URL by combining the baseURL with the requestedURL,
   * only when the requestedURL is not already an absolute URL.
   * If the requestURL is absolute, this function returns the requestedURL untouched.
   *
   * @param {string} baseURL The base URL
   * @param {string} requestedURL Absolute or relative URL to combine
   *
   * @returns {string} The combined full path
   */
  function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls, config) {
    assertValidHttpProtocolURL(requestedURL, config);
    var isRelativeUrl = !isAbsoluteURL(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
      assertValidHttpProtocolURL(baseURL, config);
      return combineURLs(baseURL, requestedURL);
    }
    return requestedURL;
  }

  function assertParamsAcyclic(params) {
    var pending = [{
      value: params
    }];
    var active = new WeakSet();
    var visited = new WeakSet();
    var _loop = function _loop() {
        var _pending$pop = pending.pop(),
          value = _pending$pop.value,
          done = _pending$pop.done;
        if (!utils$1.isPlainObject(value) && !utils$1.isArray(value)) return 0; // continue
        if (done) {
          active["delete"](value);
          return 0; // continue
        }
        if (active.has(value)) {
          throw new AxiosError('Circular reference detected in params', AxiosError.ERR_BAD_OPTION_VALUE);
        }
        if (visited.has(value)) return 0; // continue
        visited.add(value);
        active.add(value);
        pending.push({
          value: value,
          done: true
        });
        var keys = Object.keys(value);
        if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) {
          Object.getOwnPropertySymbols(value).forEach(function (key) {
            var descriptor = Object.getOwnPropertyDescriptor(value, key);
            if (descriptor && descriptor.enumerable) keys.push(key);
          });
        }
        // Shallow array elements retain fields filtered during plain-object merges.
        // Inspect reserved data properties without evaluating their accessors.
        keys.forEach(function (key) {
          if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
            var descriptor = Object.getOwnPropertyDescriptor(value, key);
            if (descriptor && utils$1.hasOwnProp(descriptor, 'value')) {
              pending.push({
                value: descriptor.value
              });
            }
          } else {
            pending.push({
              value: value[key]
            });
          }
        });
      },
      _ret;
    while (pending.length) {
      _ret = _loop();
      if (_ret === 0) continue;
    }
  }

  var headersToObject = function headersToObject(thing) {
    return thing instanceof AxiosHeaders ? _objectSpread2({}, thing) : thing;
  };
  var ownEnumerableKeys = function ownEnumerableKeys(thing) {
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) {
      return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter(function (symbol) {
        var descriptor = Object.getOwnPropertyDescriptor(thing, symbol);
        return descriptor && descriptor.enumerable;
      }));
    }
    return Object.keys(thing);
  };

  // Copy params without recursive merges so the serializer remains responsible
  // for its depth policy. Only visit defaults that contribute to the result.
  function mergeParams(a, b) {
    var pending = [];
    var copies = new WeakMap();
    var empty = {};
    function copy(target, source) {
      if (!utils$1.isPlainObject(source)) {
        return utils$1.isArray(source) ? source.slice() : source;
      }
      var base = utils$1.isPlainObject(target) ? target : empty;
      var bases = copies.get(source);
      if (!bases) {
        bases = new WeakMap();
        copies.set(source, bases);
      }
      if (bases.has(base)) return bases.get(base);
      var result = {};
      bases.set(base, result);
      pending.push({
        base: base,
        source: source,
        result: result
      });
      return result;
    }
    var result = utils$1.isUndefined(b) ? copy(undefined, a) : copy(a, b);
    var _loop = function _loop() {
      var _pending$pop = pending.pop(),
        base = _pending$pop.base,
        source = _pending$pop.source,
        target = _pending$pop.result;
      var baseKeys = new Set(ownEnumerableKeys(base));
      var sourceKeys = new Set(ownEnumerableKeys(source));
      var keys = new Set([].concat(_toConsumableArray(baseKeys), _toConsumableArray(sourceKeys)));
      keys.forEach(function (key) {
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        var hasSource = sourceKeys.has(key);
        var value = hasSource ? source[key] : undefined;
        var previous = (!hasSource || utils$1.isPlainObject(value)) && baseKeys.has(key) ? base[key] : undefined;
        target[key] = hasSource ? copy(previous, value) : copy(undefined, previous);
      });
    };
    while (pending.length) {
      _loop();
    }
    assertParamsAcyclic(result);
    return result;
  }
  function getMergedValue(target, source, prop, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({
        caseless: caseless
      }, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(a, b, prop, caseless) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(a, b, prop, caseless);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a, prop, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }
  function getMergedTransitionalOption(config1, config2, prop) {
    var transitional2 = utils$1.hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
    if (!utils$1.isUndefined(transitional2)) {
      if (utils$1.isPlainObject(transitional2)) {
        if (utils$1.hasOwnProp(transitional2, prop)) {
          return transitional2[prop];
        }
      } else {
        return undefined;
      }
    }
    var transitional1 = utils$1.hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
    if (utils$1.isPlainObject(transitional1) && utils$1.hasOwnProp(transitional1, prop)) {
      return transitional1[prop];
    }
    return undefined;
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop, config1, config2) {
    if (utils$1.hasOwnProp(config2, prop)) {
      return getMergedValue(a, b);
    } else if (utils$1.hasOwnProp(config1, prop)) {
      return getMergedValue(undefined, a);
    }
  }
  function mergeHeaders(a, b, prop) {
    return mergeDeepProperties(headersToObject(a), headersToObject(b), prop, true);
  }

  // Null-proto, frozen descriptor so a polluted Object.prototype.get cannot turn
  // this data descriptor into an accessor descriptor on the way in.
  // defineProperty only reads it, so one shared instance serves every call.
  var hasOwnPropertyDescriptor = Object.freeze({
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: false,
    writable: true,
    configurable: true
  });

  // The strategy table and the strategies above are stateless, so they are
  // built once at module load instead of on every call: mergeConfig runs at
  // most twice per request (once from a method alias, once from `_request`).
  var mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    params: mergeParams,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutErrorMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    allowedSocketPaths: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: mergeHeaders
  };

  /**
   * Config-specific merge-function which creates a new config-object
   * by merging two configuration objects together.
   *
   * @param {Object} config1
   * @param {Object} config2
   *
   * @returns {Object} New object resulting from merging config2 to config1
   */
  function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};

    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    var config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', hasOwnPropertyDescriptor);
    var keys = ownEnumerableKeys(_objectSpread2(_objectSpread2({}, config1), config2));
    for (var i = 0, len = keys.length; i < len; i++) {
      var prop = keys[i];
      if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') continue;
      var merge = utils$1.hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
      var a = utils$1.hasOwnProp(config1, prop) ? config1[prop] : undefined;
      var b = utils$1.hasOwnProp(config2, prop) ? config2[prop] : undefined;
      var configValue = merge === mergeDirectKeys ? merge(a, b, prop, config1, config2) : merge(a, b, prop);
      utils$1.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    }
    if (utils$1.hasOwnProp(config2, 'validateStatus') && utils$1.isUndefined(config2.validateStatus) && getMergedTransitionalOption(config1, config2, 'validateStatusUndefinedResolves') === false) {
      if (utils$1.hasOwnProp(config1, 'validateStatus')) {
        config.validateStatus = getMergedValue(undefined, config1.validateStatus);
      } else {
        delete config.validateStatus;
      }
    }
    return config;
  }

  var FORM_DATA_CONTENT_HEADERS = ['content-type', 'content-length'];

  /**
   * Apply the headers generated by a FormData implementation to the request headers,
   * honoring the `formDataHeaderPolicy` option: with 'content-only', copy only the
   * content-* headers; otherwise merge all of them.
   *
   * @param {AxiosHeaders} headers - the request headers to mutate
   * @param {Object | null | undefined} formHeaders - headers produced by the FormData implementation
   * @param {String} [policy] - the resolved `formDataHeaderPolicy` config value
   *
   * @returns {void}
   */
  function setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
      headers.set(formHeaders);
      return;
    }
    Object.entries(formHeaders || {}).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];
      if (FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) {
        headers.set(key, val);
      }
    });
  }

  /**
   * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
   * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
   *
   * @param {string} str The string to encode
   *
   * @returns {string} UTF-8 bytes as a Latin-1 string
   */
  var encodeUTF8$1 = function encodeUTF8(str) {
    return encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, function (_, hex) {
      return String.fromCharCode(parseInt(hex, 16));
    });
  };
  var readCookie = function readCookie(name) {
    return cookies.read(name);
  };
  function resolveConfig(config) {
    var readXsrfCookie = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : readCookie;
    var newConfig = mergeConfig({}, config);

    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    var own = function own(key) {
      return utils$1.hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    };
    var data = own('data');
    var withXSRFToken = own('withXSRFToken');
    var xsrfHeaderName = own('xsrfHeaderName');
    var xsrfCookieName = own('xsrfCookieName');
    var headers = own('headers');
    var auth = own('auth');
    var baseURL = own('baseURL');
    var allowAbsoluteUrls = own('allowAbsoluteUrls');
    var url = own('url');
    newConfig.headers = headers = AxiosHeaders.from(headers);
    newConfig.url = buildURL(buildFullPath(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));

    // HTTP basic authentication
    if (auth) {
      var username = utils$1.getSafeProp(auth, 'username') || '';
      var password = utils$1.getSafeProp(auth, 'password') || '';
      var transitional = own('transitional');
      var encodeUsername = transitional && utils$1.hasOwnProp(transitional, 'encodeBasicAuthUsername') && transitional.encodeBasicAuthUsername === true;
      try {
        headers.set('Authorization',
        // Preserve legacy username bytes unless the caller opts in to UTF-8.
        'Basic ' + btoa((encodeUsername ? encodeUTF8$1(username) : username) + ':' + (password ? encodeUTF8$1(password) : '')));
      } catch (e) {
        throw AxiosError.from(e, AxiosError.ERR_BAD_OPTION_VALUE, config);
      }
    }
    if (utils$1.isFormData(data)) {
      var getHeaders = utils$1.getSafeProp(data, 'getHeaders');
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv || utils$1.isReactNative(data)) {
        headers.setContentType(undefined); // browser/web worker/RN handles it
      } else if (utils$1.isFunction(getHeaders)) {
        // Node.js FormData (like form-data package)
        setFormDataHeaders(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
      }
    }

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.

    if (platform.hasStandardBrowserEnv) {
      if (utils$1.isFunction(withXSRFToken)) {
        withXSRFToken = withXSRFToken(newConfig);
      }

      // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
      // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
      // the XSRF token cross-origin.
      var shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && isURLSameOrigin(newConfig.url);
      if (shouldSendXSRF) {
        var xsrfValue = xsrfHeaderName && xsrfCookieName && readXsrfCookie(xsrfCookieName);
        if (xsrfValue) {
          headers.set(xsrfHeaderName, xsrfValue);
        }
      }
    }
    return newConfig;
  }

  var isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
  var xhrAdapter = isXHRAdapterSupported && function (config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
      var useAsyncXsrf;
      try {
        var store = platform.hasStandardBrowserEnv && typeof window !== 'undefined' && window.cookieStore;
        useAsyncXsrf = store && utils$1.isFunction(store.get);
      } catch (e) {
        // A restricted Cookie Store getter must retain the synchronous fallback.
      }
      var xsrfCookieName;
      var _config = resolveConfig(config, useAsyncXsrf ? function (name) {
        xsrfCookieName = name;
        return null;
      } : undefined);
      var requestData = _config.data;
      var requestHeaders = AxiosHeaders.from(_config.headers).normalize();
      var responseType = _config.responseType,
        onUploadProgress = _config.onUploadProgress,
        onDownloadProgress = _config.onDownloadProgress;
      var onCanceled;
      var timeoutId;
      var uploadThrottled, downloadThrottled;
      var flushUpload, flushDownload, flushDownloadWithEvent;
      function done() {
        clearTimeout(timeoutId);
        // A final progress callback must not prevent the remaining cleanup.
        // Report errors asynchronously, as onloadend and the throttle timer do.
        try {
          flushUpload && flushUpload(); // flush events
        } catch (err) {
          setTimeout(function () {
            throw err;
          });
        }
        try {
          flushDownload && flushDownload(); // flush events
        } catch (err) {
          setTimeout(function () {
            throw err;
          });
        }

        // A flush can synchronously cancel the request and reenter done().
        // In that case the inner call has already detached these listeners.
        if (request) {
          downloadThrottled && request.removeEventListener('progress', downloadThrottled);
          if (request.upload) {
            uploadThrottled && request.upload.removeEventListener('progress', uploadThrottled);
            flushUpload && request.upload.removeEventListener('loadend', flushUpload);
          }
        }
        _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
        _config.signal && _config.signal.removeEventListener('abort', onCanceled);
      }
      var request = new XMLHttpRequest();
      request.open(_config.method.toUpperCase(), _config.url, true);

      // Set the request timeout in MS
      request.timeout = _config.timeout;
      function onloadend(event) {
        if (!request) {
          return;
        }

        // Status 0 means no response was received, which onerror and onabort normally
        // reject before this runs. Firefox 152 fires only readystatechange and loadend for
        // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
        // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
        // onabort raised on Firefox 151. Reads over file:, which some environments report as
        // status 0 on success, are excluded by the request URL's scheme after browser-style
        // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
        // by responseURL where implemented.
        if (request.status === 0 && (parseProtocol(normalizeURLForProtocolCheck(_config.url)) || parseProtocol(platform.origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
          reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));
          done();

          // Clean up request
          request = null;
          return;
        }

        // When loadend is still dispatching, flushing with it gives progress
        // listeners a final delivery whose event has a live target. The legacy
        // ready-state fallback has no event, so replay its pending progress.
        // A throwing listener must not block settlement; rethrow asynchronously,
        // matching how listener errors surface on the throttle timer path.
        try {
          if (event) {
            flushDownloadWithEvent && flushDownloadWithEvent(event);
          } else {
            flushDownload && flushDownload();
          }
        } catch (err) {
          setTimeout(function () {
            throw err;
          });
        }

        // A final progress callback can cancel the request synchronously.
        if (!request) {
          return;
        }

        // Prepare the response
        var responseHeaders = AxiosHeaders.from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
        var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
        var response = {
          data: responseData,
          status: request.status,
          statusText: request.statusText,
          headers: responseHeaders,
          config: config,
          request: request
        };
        settle(function _resolve(value) {
          resolve(value);
          done();
        }, function _reject(err) {
          reject(err);
          done();
        }, response);

        // Clean up request
        request = null;
      }
      if ('onloadend' in request) {
        // Use onloadend if available
        request.onloadend = onloadend;
      } else {
        // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
          if (!request || request.readyState !== 4) {
            return;
          }

          // The request errored out and we didn't get a response, this will be
          // handled by onerror instead
          // With one exception: request that using file: protocol, most browsers
          // will return status as 0 even though it's a successful request
          if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) {
            return;
          }
          // readystate handler is calling before onerror or ontimeout handlers,
          // so we should call onloadend on the next 'tick'
          setTimeout(onloadend);
        };
      }

      // Handle browser request cancellation (as opposed to a manual cancellation)
      request.onabort = function handleAbort() {
        if (!request) {
          return;
        }
        reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));
        done();

        // Clean up request
        request = null;
      };

      // Handle low level network errors
      request.onerror = function handleError(event) {
        // Browsers deliver a ProgressEvent in XHR onerror
        // (message may be empty; when present, surface it)
        // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
        var msg = event && event.message ? event.message : 'Network Error';
        var err = new AxiosError(msg, AxiosError.ERR_NETWORK, config, request);
        // attach the underlying event for consumers who want details
        err.event = event || null;
        reject(err);
        done();
        request = null;
      };

      // Handle timeout
      request.ontimeout = function handleTimeout() {
        if (!request) return;
        var timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
        var transitional = _config.transitional || transitionalDefaults;
        if (_config.timeoutErrorMessage) {
          timeoutErrorMessage = _config.timeoutErrorMessage;
        }
        reject(new AxiosError(timeoutErrorMessage, transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED, config, request));
        done();

        // Clean up request
        request = null;
      };

      // Remove Content-Type if data is undefined
      requestData === undefined && requestHeaders.setContentType(null);

      // Add withCredentials to request if needed
      if (!utils$1.isUndefined(_config.withCredentials)) {
        request.withCredentials = !!_config.withCredentials;
      }

      // Add responseType to request if needed
      if (responseType && responseType !== 'json') {
        request.responseType = _config.responseType;
      }

      // Handle progress if needed
      if (onDownloadProgress) {
        var _progressEventReducer = progressEventReducer(onDownloadProgress, true);
        var _progressEventReducer2 = _slicedToArray(_progressEventReducer, 3);
        downloadThrottled = _progressEventReducer2[0];
        flushDownload = _progressEventReducer2[1];
        flushDownloadWithEvent = _progressEventReducer2[2];
        request.addEventListener('progress', downloadThrottled);
      }

      // Not all browsers support upload events
      if (onUploadProgress && request.upload) {
        var _progressEventReducer3 = progressEventReducer(onUploadProgress);
        var _progressEventReducer4 = _slicedToArray(_progressEventReducer3, 2);
        uploadThrottled = _progressEventReducer4[0];
        flushUpload = _progressEventReducer4[1];
        request.upload.addEventListener('progress', uploadThrottled);
        request.upload.addEventListener('loadend', flushUpload);
      }
      if (_config.cancelToken || _config.signal) {
        // Handle cancellation
        // eslint-disable-next-line func-names
        onCanceled = function onCanceled(cancel) {
          if (!request) {
            return;
          }
          reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
          var xhr = request;
          done();
          request = null;
          xhr.abort();
        };
        _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
        if (!request) return;
        if (_config.signal) {
          _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
      }
      if (!request) return;
      var protocol = parseProtocol(_config.url);
      if (protocol && !platform.protocols.includes(protocol)) {
        reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
        done();
        return;
      }
      var sendRequest = function sendRequest() {
        if (!request) return;
        // Apply headers after an asynchronous XSRF read so existing headers are
        // replaced through AxiosHeaders rather than appended by the native XHR.
        if ('setRequestHeader' in request) {
          utils$1.forEach(toByteStringHeaderObject(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
          });
        }
        request.send(requestData || null);
      };
      if (xsrfCookieName) {
        // Native XHR timeout starts at send(). Cover cookie preparation and the
        // subsequent request with the same budget and existing timeout handler.
        var now = typeof performance !== 'undefined' && utils$1.isFunction(performance.now) ? function () {
          return performance.now();
        } : Date.now;
        var deadline = request.timeout > 0 ? now() + Number(request.timeout) : undefined;
        var abortOnTimeout = function abortOnTimeout() {
          if (!request) return;
          var xhr = request;
          xhr.ontimeout();
          xhr.abort();
        };
        if (deadline !== undefined) {
          var _scheduleTimeout = function scheduleTimeout() {
            var remaining = deadline - now();
            if (remaining > 0) {
              // Browser timers overflow above the signed 32-bit delay limit.
              timeoutId = setTimeout(_scheduleTimeout, Math.min(remaining, 0x7fffffff));
            } else {
              abortOnTimeout();
            }
          };
          _scheduleTimeout();
        }
        cookies.readAsync(xsrfCookieName).then(function (value) {
          if (!request) return;
          // Promise callbacks may run before an overdue timer after a busy task.
          if (deadline !== undefined && now() >= deadline) {
            abortOnTimeout();
            return;
          }
          if (value) {
            var headerName = utils$1.hasOwnProp(_config, 'xsrfHeaderName') && _config.xsrfHeaderName;
            requestHeaders.set(headerName, value);
          }
          sendRequest();
        })["catch"](function (error) {
          if (!request) return;
          reject(AxiosError.from(error, null, config, request));
          done();
          request = null;
        });
      } else {
        sendRequest();
      }
    });
  };

  var composeSignals = function composeSignals(signals, timeout) {
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) {
      return;
    }
    var controller = new AbortController();
    var aborted = false;
    var onabort = function onabort(reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        var err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof AxiosError ? err : new CanceledError(err instanceof Error ? err.message : err));
      }
    };
    var timer = timeout && setTimeout(function () {
      timer = null;
      onabort(new AxiosError("timeout of ".concat(timeout, "ms exceeded"), AxiosError.ETIMEDOUT));
    }, timeout);
    var unsubscribe = function unsubscribe() {
      if (!signals) {
        return;
      }
      timer && clearTimeout(timer);
      timer = null;
      signals.forEach(function (signal) {
        var unsubscribeSignal = utils$1.getSafeProp(signal, 'unsubscribe');
        utils$1.isFunction(unsubscribeSignal) ? unsubscribeSignal.call(signal, onabort) : signal.removeEventListener('abort', onabort);
      });
      signals = null;
    };
    signals.forEach(function (signal) {
      if (aborted) {
        return;
      }
      if (signal.aborted) {
        onabort.call(signal);
        return;
      }
      signal.addEventListener('abort', onabort, {
        once: true
      });
    });
    var signal = controller.signal;
    signal.unsubscribe = function () {
      return utils$1.asap(unsubscribe);
    };
    return signal;
  };

  var streamChunk = /*#__PURE__*/_regenerator().m(function streamChunk(chunk, chunkSize) {
    var len, pos, end;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          len = chunk.byteLength;
          if (!(!chunkSize || len < chunkSize)) {
            _context.n = 2;
            break;
          }
          _context.n = 1;
          return chunk;
        case 1:
          return _context.a(2);
        case 2:
          pos = 0;
        case 3:
          if (!(pos < len)) {
            _context.n = 5;
            break;
          }
          end = pos + chunkSize;
          _context.n = 4;
          return chunk.slice(pos, end);
        case 4:
          pos = end;
          _context.n = 3;
          break;
        case 5:
          return _context.a(2);
      }
    }, streamChunk);
  });
  var readBytes = /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator(/*#__PURE__*/_regenerator().m(function _callee(iterable, chunkSize) {
      var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, chunk, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context2.p = 1;
            _iterator = _asyncIterator(readStream(iterable));
          case 2:
            _context2.n = 3;
            return _awaitAsyncGenerator(_iterator.next());
          case 3:
            if (!(_iteratorAbruptCompletion = !(_step = _context2.v).done)) {
              _context2.n = 5;
              break;
            }
            chunk = _step.value;
            return _context2.d(_regeneratorValues(_asyncGeneratorDelegate(_asyncIterator(streamChunk(chunk, chunkSize)))), 4);
          case 4:
            _iteratorAbruptCompletion = false;
            _context2.n = 2;
            break;
          case 5:
            _context2.n = 7;
            break;
          case 6:
            _context2.p = 6;
            _t = _context2.v;
            _didIteratorError = true;
            _iteratorError = _t;
          case 7:
            _context2.p = 7;
            _context2.p = 8;
            if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) {
              _context2.n = 9;
              break;
            }
            _context2.n = 9;
            return _awaitAsyncGenerator(_iterator["return"]());
          case 9:
            _context2.p = 9;
            if (!_didIteratorError) {
              _context2.n = 10;
              break;
            }
            throw _iteratorError;
          case 10:
            return _context2.f(9);
          case 11:
            return _context2.f(7);
          case 12:
            return _context2.a(2);
        }
      }, _callee, null, [[8,, 9, 11], [1, 6, 7, 12]]);
    }));
    return function readBytes(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var readStream = /*#__PURE__*/function () {
    var _ref2 = _wrapAsyncGenerator(/*#__PURE__*/_regenerator().m(function _callee2(stream) {
      var reader, _yield$_awaitAsyncGen, done, value;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            if (!stream[Symbol.asyncIterator]) {
              _context3.n = 2;
              break;
            }
            return _context3.d(_regeneratorValues(_asyncGeneratorDelegate(_asyncIterator(stream))), 1);
          case 1:
            return _context3.a(2);
          case 2:
            reader = stream.getReader();
            _context3.p = 3;
          case 4:
            _context3.n = 5;
            return _awaitAsyncGenerator(reader.read());
          case 5:
            _yield$_awaitAsyncGen = _context3.v;
            done = _yield$_awaitAsyncGen.done;
            value = _yield$_awaitAsyncGen.value;
            if (!done) {
              _context3.n = 6;
              break;
            }
            return _context3.a(3, 8);
          case 6:
            _context3.n = 7;
            return value;
          case 7:
            _context3.n = 4;
            break;
          case 8:
            _context3.p = 8;
            _context3.n = 9;
            return _awaitAsyncGenerator(reader.cancel());
          case 9:
            return _context3.f(8);
          case 10:
            return _context3.a(2);
        }
      }, _callee2, null, [[3,, 8, 10]]);
    }));
    return function readStream(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  var trackStream = function trackStream(stream, chunkSize, onProgress, onFinish) {
    var iterator = readBytes(stream, chunkSize);
    var bytes = 0;
    var done;
    var _onFinish = function _onFinish(e) {
      if (!done) {
        done = true;
        onFinish && onFinish(e);
      }
    };
    return new ReadableStream({
      pull: function pull(controller) {
        return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
          var _yield$iterator$next, _done, value, len, loadedBytes, _t2;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.p = _context4.n) {
              case 0:
                _context4.p = 0;
                _context4.n = 1;
                return iterator.next();
              case 1:
                _yield$iterator$next = _context4.v;
                _done = _yield$iterator$next.done;
                value = _yield$iterator$next.value;
                if (!_done) {
                  _context4.n = 2;
                  break;
                }
                _onFinish();
                controller.close();
                return _context4.a(2);
              case 2:
                len = value.byteLength;
                if (onProgress) {
                  loadedBytes = bytes += len;
                  onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
                _context4.n = 4;
                break;
              case 3:
                _context4.p = 3;
                _t2 = _context4.v;
                _onFinish(_t2);
                throw _t2;
              case 4:
                return _context4.a(2);
            }
          }, _callee3, null, [[0, 3]]);
        }))();
      },
      cancel: function cancel(reason) {
        _onFinish(reason);
        return iterator["return"]();
      }
    }, {
      highWaterMark: 2
    });
  };

  var CRLF = '\r\n';
  var normalizeLines = function normalizeLines(value) {
    return String(value).replace(/\r\n|\r|\n/g, CRLF);
  };
  var escapeName = function escapeName(value) {
    return String(value).replace(/[\r\n"]/g, function (_char) {
      return _char === '\r' ? '%0D' : _char === '\n' ? '%0A' : '%22';
    });
  };

  // Count UTF-8 bytes without allocating an encoded copy of a field. FormData
  // string values normalize line endings; Blob/File contents remain unchanged.
  var stringBytes = function stringBytes(value, normalize) {
    var length = 0;
    for (var i = 0; i < value.length; i++) {
      var code = value.charCodeAt(i);
      if (normalize && (code === 13 || code === 10)) {
        if (code === 13 && value.charCodeAt(i + 1) === 10) i++;
        length += 2;
      } else if (code < 0x80) {
        length++;
      } else if (code < 0x800) {
        length += 2;
      } else if (code >= 0xd800 && code <= 0xdbff && value.charCodeAt(i + 1) >= 0xdc00 && value.charCodeAt(i + 1) <= 0xdfff) {
        length += 4;
        i++;
      } else {
        length += 3;
      }
    }
    return length;
  };

  // Describe serialization failures independently of any request library.
  var FormDataError = /*#__PURE__*/function (_TypeError) {
    function FormDataError(message, reason) {
      var _this;
      _classCallCheck(this, FormDataError);
      _this = _callSuper(this, FormDataError, [message]);
      _this.name = 'FormDataError';
      _this.reason = reason;
      return _this;
    }
    _inherits(FormDataError, _TypeError);
    return _createClass(FormDataError);
  }(/*#__PURE__*/_wrapNativeSuper(TypeError));

  // The caller supplies the boundary, Blob implementation, and limit error.
  function formDataToBlob(form, Blob, limit, limitError, boundary) {
    if (!utils$1.isFunction(Blob)) {
      throw new FormDataError('Blob is not supported', 'blob');
    }
    if (!utils$1.isString(boundary) || !/^[A-Za-z0-9'()+_,./:=? -]{1,70}$/.test(boundary) || / $/.test(boundary)) {
      throw new FormDataError('Invalid multipart boundary', 'boundary');
    }
    var footer = '--' + boundary + '--' + CRLF;
    var length = footer.length;
    var parts = [];
    var checkLength = function checkLength(extra) {
      if (length + extra > limit) throw limitError();
    };
    checkLength(0);
    var _iterator = _createForOfIteratorHelper(form),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          name = _step$value[0],
          value = _step$value[1];
        var isString = utils$1.isString(value);
        var valueLength = isString ? stringBytes(value, true) : value.size;
        if (!Number.isFinite(valueLength) || valueLength < 0) {
          throw new FormDataError('Unsupported FormData part size', 'part');
        }
        // Reject large values and names before building normalized header strings.
        checkLength(valueLength + stringBytes(name, true) + (!isString && value.name ? stringBytes(value.name, false) : 0) + (!isString && value.type ? stringBytes(value.type, false) : 0));
        var header = '--' + boundary + CRLF + 'Content-Disposition: form-data; name="' + escapeName(normalizeLines(name)) + '"';
        if (!isString) {
          header += '; filename="' + escapeName(utils$1.isString(value.name) ? value.name : 'blob') + '"' + CRLF + 'Content-Type: ' + String(value.type || 'application/octet-stream').replace(/[\r\n]/g, '');
        }
        header += CRLF + CRLF;
        var partLength = stringBytes(header, false) + valueLength + CRLF.length;
        checkLength(partLength);
        length += partLength;
        parts.push({
          header: header,
          value: value,
          isString: isString
        });
      }

      // Native Blob composition retains existing Blob/File data. No file is read
      // and no complete multipart ArrayBuffer is created to determine its length.
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var blobParts = [];
    for (var _i = 0, _parts = parts; _i < _parts.length; _i++) {
      var part = _parts[_i];
      blobParts.push(part.header, part.isString ? normalizeLines(part.value) : part.value, CRLF);
    }
    blobParts.push(footer);
    return new Blob(blobParts, {
      type: 'multipart/form-data; boundary=' + boundary
    });
  }

  function createMultipartBody(form, Blob, limit, limitError, boundary) {
    // Report missing Blob support before trying to select a random source.
    if (!utils$1.isFunction(Blob)) {
      throw new AxiosError('Blob is not supported', AxiosError.ERR_NOT_SUPPORT);
    }
    if (boundary === undefined) {
      if (utils$1.isFunction(platform.generateString)) {
        boundary = 'axios-' + platform.generateString(36, '0123456789abcdef');
      } else {
        var crypto = utils$1.global.crypto;
        if (!crypto || !utils$1.isFunction(crypto.getRandomValues)) {
          throw new AxiosError('Random byte generation is not supported', AxiosError.ERR_NOT_SUPPORT);
        }
        var random = new Uint8Array(18);
        crypto.getRandomValues(random);
        boundary = 'axios-' + Array.from(random, function (value) {
          return ('0' + value.toString(16)).slice(-2);
        }).join('');
      }
    }
    try {
      return formDataToBlob(form, Blob, limit, limitError, boundary);
    } catch (error) {
      if (error instanceof FormDataError) {
        var code = error.reason === 'boundary' ? AxiosError.ERR_BAD_OPTION_VALUE : AxiosError.ERR_BAD_REQUEST;
        throw new AxiosError(error.message, code);
      }
      throw error;
    }
  }

  /**
   * Estimate data: URL byte lengths *without* allocating large buffers.
   * - Fetch percent-decodes a base64 body before decoding it.
   * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
   *   percent-decoded body, including ignored characters and content after padding.
   * - Non-base64 data is percent-decoded and then encoded as UTF-8.
   */
  var isHexDigit = function isHexDigit(charCode) {
    return charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
  };
  var isPercentEncodedByte = function isPercentEncodedByte(str, i, len) {
    return i + 2 < len && isHexDigit(str.charCodeAt(i + 1)) && isHexDigit(str.charCodeAt(i + 2));
  };
  var hexValue = function hexValue(charCode) {
    return charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
  };
  var isBase64Char = function isBase64Char(charCode) {
    return charCode >= 65 && charCode <= 90 ||
    // A-Z
    charCode >= 97 && charCode <= 122 ||
    // a-z
    charCode >= 48 && charCode <= 57 ||
    // 0-9
    charCode === 43 ||
    // +
    charCode === 47 ||
    // /
    charCode === 45 ||
    // - (base64url)
    charCode === 95;
  }; // _ (base64url)

  var isBase64Whitespace = function isBase64Whitespace(charCode) {
    return charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
  };
  var base64Bytes = function base64Bytes(significant) {
    var groups = Math.floor(significant / 4);
    var remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
  };

  // Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
  // upper bound even when Buffer.from later ignores characters or stops at '='.
  var estimateBase64BufferAllocation = function estimateBase64BufferAllocation(body) {
    var len = body.length;
    var padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */) {
      padding++;
      if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */) {
        padding++;
      }
    }
    return Math.floor((len - padding) * 3 / 4);
  };
  var estimatePercentDecodedBase64Bytes = function estimatePercentDecodedBase64Bytes(body) {
    var len = body.length;
    var significant = 0;
    var padding = 0;
    var invalid = false;
    for (var i = 0; i < len; i++) {
      var code = body.charCodeAt(i);
      if (code === 37 /* '%' */ && isPercentEncodedByte(body, i, len)) {
        code = hexValue(body.charCodeAt(i + 1)) * 16 + hexValue(body.charCodeAt(i + 2));
        i += 2;
      }
      if (isBase64Whitespace(code)) {
        continue;
      }
      if (code === 61 /* '=' */) {
        padding++;
        continue;
      }
      if (!isBase64Char(code) || padding > 0) {
        invalid = true;
        continue;
      }
      significant++;
    }

    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) {
      return estimateBase64BufferAllocation(body);
    }
    return base64Bytes(significant);
  };
  var estimateDataURLBytes = function estimateDataURLBytes(url, estimateBase64, base64Pattern) {
    if (!url || typeof url !== 'string') return 0;
    if (!/^data:/i.test(url)) return 0;
    var comma = url.indexOf(',');
    if (comma < 0) return 0;
    var meta = url.slice(5, comma);
    var body = url.slice(comma + 1);
    var isBase64 = base64Pattern.test(meta);
    if (isBase64) {
      return estimateBase64(body);
    }

    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    var bytes = 0;
    for (var i = 0, len = body.length; i < len; i++) {
      var c = body.charCodeAt(i);
      if (c === 37 /* '%' */ && isPercentEncodedByte(body, i, len)) {
        bytes += 1;
        i += 2;
      } else if (c < 0x80) {
        bytes += 1;
      } else if (c < 0x800) {
        bytes += 2;
      } else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
        var next = body.charCodeAt(i + 1);
        if (next >= 0xdc00 && next <= 0xdfff) {
          bytes += 4;
          i++;
        } else {
          bytes += 3;
        }
      } else {
        bytes += 3;
      }
    }
    return bytes;
  };

  /**
   * Estimate the percent-decoded payload size used by Fetch data: URLs.
   *
   * @param {string} url
   * @returns {number}
   */
  function estimateDataURLDecodedBytes(url) {
    // Fetch removes URL fragments before processing a data: URL.
    var fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), estimatePercentDecodedBase64Bytes, /; *base64[\t\n\f\r ]*$/i);
  }

  var VERSION = "1.21.0";

  var DEFAULT_CHUNK_SIZE = 64 * 1024;
  var DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
  };
  var isFunction = utils$1.isFunction;

  /**
   * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
   * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
   *
   * @param {string} str The string to encode
   *
   * @returns {string} UTF-8 bytes as a Latin-1 string
   */
  var encodeUTF8 = function encodeUTF8(str) {
    return encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, function (_, hex) {
      return String.fromCharCode(parseInt(hex, 16));
    });
  };

  // Node's WHATWG URL parser returns `username` and `password` percent-encoded.
  // Decode before composing the `auth` option so credentials such as
  // `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
  // original value for malformed input so a bad encoding never throws.
  var decodeURIComponentSafe = function decodeURIComponentSafe(value) {
    if (!utils$1.isString(value)) {
      return value;
    }
    try {
      return decodeURIComponent(value);
    } catch (error) {
      return value;
    }
  };
  var test = function test(fn) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return !!fn.apply(void 0, args);
    } catch (e) {
      return false;
    }
  };
  var maybeWithAuthCredentials = function maybeWithAuthCredentials(url) {
    var protocolIndex = url.indexOf('://');
    var urlToCheck = url;
    if (protocolIndex !== -1) {
      urlToCheck = urlToCheck.slice(protocolIndex + 3);
    }
    return urlToCheck.includes('@') || urlToCheck.includes(':');
  };
  var factory = function factory(env) {
    var globalObject = utils$1.global !== undefined && utils$1.global !== null ? utils$1.global : globalThis;
    var ReadableStream = globalObject.ReadableStream,
      TextEncoder = globalObject.TextEncoder;
    env = utils$1.merge.call({
      skipUndefined: true
    }, {
      Request: globalObject.Request,
      Response: globalObject.Response,
      Blob: globalObject.Blob
    }, env);
    var envFetch = utils$1.hasOwnProp(env, 'fetch') ? env.fetch : undefined;
    var _env = env,
      Request = _env.Request,
      Response = _env.Response,
      Blob = _env.Blob;
    var isFetchSupported = envFetch ? isFunction(envFetch) : typeof fetch === 'function';
    var isRequestSupported = isFunction(Request);
    var isResponseSupported = isFunction(Response);
    if (!isFetchSupported) {
      return false;
    }
    var isReadableStreamSupported = isFetchSupported && isFunction(ReadableStream);
    var encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? function (encoder) {
      return function (str) {
        return encoder.encode(str);
      };
    }(new TextEncoder()) : (/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(str) {
        var _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _t = Uint8Array;
              _context.n = 1;
              return new Request(str).arrayBuffer();
            case 1:
              _t2 = _context.v;
              return _context.a(2, new _t(_t2));
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()));
    var supportsRequestStream = isRequestSupported && isReadableStreamSupported && test(function () {
      var duplexAccessed = false;
      var request = new Request(platform.origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex() {
          duplexAccessed = true;
          return 'half';
        }
      });
      var hasContentType = request.headers.has('Content-Type');
      if (request.body != null) {
        request.body.cancel();
      }
      return duplexAccessed && !hasContentType;
    });
    var supportsResponseStream = isResponseSupported && isReadableStreamSupported && test(function () {
      return utils$1.isReadableStream(new Response('').body);
    });

    // Some runtimes reject every explicit cache mode. Use own defaults for both
    // probes so unrelated polluted options cannot affect cache-mode detection.
    var requestDefaults = Object.assign(Object.create(null), DEFAULT_REQUEST_OPTIONS);
    if (isRequestSupported && !test(function () {
      return new Request(platform.origin, requestDefaults);
    })) {
      delete requestDefaults.cache;

      // Only omit cache when that makes Request construction succeed. Otherwise
      // retain the explicit default that protects supporting runtimes from pollution.
      if (!test(function () {
        return new Request(platform.origin, requestDefaults);
      })) {
        requestDefaults.cache = DEFAULT_REQUEST_OPTIONS.cache;
      }
    }
    var resolvers = {
      stream: supportsResponseStream && function (res) {
        return res.body;
      }
    };
    isFetchSupported && function () {
      ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(function (type) {
        !resolvers[type] && (resolvers[type] = function (res, config) {
          var method = res && res[type];
          if (method) {
            return method.call(res);
          }
          throw new AxiosError("Response type '".concat(type, "' is not supported"), AxiosError.ERR_NOT_SUPPORT, config);
        });
      });
    }();
    var getBodyLength = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(body) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(body == null)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, 0);
            case 1:
              if (!utils$1.isBlob(body)) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, body.size);
            case 2:
              if (!(utils$1.isArrayBufferView(body) || utils$1.isArrayBuffer(body))) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2, body.byteLength);
            case 3:
              if (utils$1.isURLSearchParams(body)) {
                body = body + '';
              }
              if (!utils$1.isString(body)) {
                _context2.n = 5;
                break;
              }
              _context2.n = 4;
              return encodeText(body);
            case 4:
              return _context2.a(2, _context2.v.byteLength);
            case 5:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function getBodyLength(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    var resolveBodyLength = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(headers, body) {
        var length;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              length = utils$1.toFiniteNumber(headers.getContentLength());
              return _context3.a(2, length == null ? getBodyLength(body) : length);
          }
        }, _callee3);
      }));
      return function resolveBodyLength(_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }();
    return /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(config) {
        var _resolveConfig, url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, _resolveConfig$withCr, withCredentials, fetchOptions, maxContentLength, maxBodyLength, maxRedirects, hasMaxContentLength, hasMaxBodyLength, own, _fetch, composedSignal, request, unsubscribe, requestContentLength, pendingBodyError, pendingResponseError, maxBodyLengthError, auth, configAuth, username, password, parsedURL, urlUsername, urlPassword, estimated, formContentType, formBoundary, parameters, outboundLength, mustEnforceStreamBody, trackRequestStream, _request, contentTypeHeader, _ref5, _ref6, onProgress, flush, isCredentialsSupported, contentType, safeFetchOptions, resolvedOptions, response, responseHeaders, declaredLength, isStreamResponse, options, responseContentLength, _ref7, _ref8, _onProgress, _flush, bytesRead, onChunkProgress, responseData, materializedSize, canceledError, networkError, _t3, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _resolveConfig = resolveConfig(config), url = _resolveConfig.url, method = _resolveConfig.method, data = _resolveConfig.data, signal = _resolveConfig.signal, cancelToken = _resolveConfig.cancelToken, timeout = _resolveConfig.timeout, onDownloadProgress = _resolveConfig.onDownloadProgress, onUploadProgress = _resolveConfig.onUploadProgress, responseType = _resolveConfig.responseType, headers = _resolveConfig.headers, _resolveConfig$withCr = _resolveConfig.withCredentials, withCredentials = _resolveConfig$withCr === void 0 ? 'same-origin' : _resolveConfig$withCr, fetchOptions = _resolveConfig.fetchOptions, maxContentLength = _resolveConfig.maxContentLength, maxBodyLength = _resolveConfig.maxBodyLength, maxRedirects = _resolveConfig.maxRedirects;
              hasMaxContentLength = utils$1.isNumber(maxContentLength) && maxContentLength > -1;
              hasMaxBodyLength = utils$1.isNumber(maxBodyLength) && maxBodyLength > -1;
              own = function own(key) {
                return utils$1.hasOwnProp(config, key) ? config[key] : undefined;
              };
              _fetch = envFetch || fetch;
              responseType = responseType ? (responseType + '').toLowerCase() : 'text';
              composedSignal = composeSignals([signal, cancelToken && cancelToken.toAbortSignal()], timeout);
              request = null;
              unsubscribe = composedSignal && composedSignal.unsubscribe && function () {
                composedSignal.unsubscribe();
              };
              // AxiosErrors we raise while request or response bodies are being streamed. Captured
              // by identity so the catch block can surface it directly, regardless of
              // how the runtime wraps the resulting fetch rejection (undici exposes it
              // as `err.cause`; some browsers drop the original error entirely).
              pendingBodyError = null;
              pendingResponseError = null;
              maxBodyLengthError = function maxBodyLengthError() {
                return new AxiosError('Request body larger than maxBodyLength limit', AxiosError.ERR_BAD_REQUEST, config, request);
              };
              _context4.p = 1;
              // HTTP basic authentication
              auth = undefined;
              configAuth = own('auth');
              if (configAuth) {
                username = utils$1.getSafeProp(configAuth, 'username') || '';
                password = utils$1.getSafeProp(configAuth, 'password') || '';
                auth = {
                  username: username,
                  password: password
                };
              }
              if (maybeWithAuthCredentials(url)) {
                parsedURL = new URL(url, platform.origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                  urlUsername = decodeURIComponentSafe(parsedURL.username);
                  urlPassword = decodeURIComponentSafe(parsedURL.password);
                  auth = {
                    username: urlUsername,
                    password: urlPassword
                  };
                }
                if (parsedURL.username || parsedURL.password) {
                  parsedURL.username = '';
                  parsedURL.password = '';
                  url = parsedURL.href;
                }
              }
              if (auth) {
                headers["delete"]('authorization');
                headers.set('Authorization', 'Basic ' + btoa(encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
              }

              // Enforce maxContentLength for data: URLs up-front so we never materialize
              // an oversized payload. The HTTP adapter applies the same check (see http.js
              // "if (protocol === 'data:')" branch).
              if (!(hasMaxContentLength && parsedURL && parsedURL.protocol === 'data:')) {
                _context4.n = 2;
                break;
              }
              estimated = estimateDataURLDecodedBytes(parsedURL.href);
              if (!(estimated > maxContentLength)) {
                _context4.n = 2;
                break;
              }
              throw new AxiosError('maxContentLength size of ' + maxContentLength + ' exceeded', AxiosError.ERR_BAD_RESPONSE, config, request);
            case 2:
              formContentType = utils$1.isSpecCompliantForm(data) && AxiosHeaders.from(own('headers')).getContentType();
              if (utils$1.isString(formContentType) && /^multipart\/form-data(?:\s*;|$)/i.test(formContentType.trim())) {
                parameters = AxiosHeaders.parseParameters(formContentType);
                if (utils$1.hasOwnProp(parameters, 'boundary')) formBoundary = parameters.boundary;
              }
              if (utils$1.isSpecCompliantForm(data) && method !== 'get' && method !== 'head' && (hasMaxBodyLength || onUploadProgress && supportsRequestStream || formBoundary !== undefined)) {
                data = createMultipartBody(data, Blob, hasMaxBodyLength ? maxBodyLength : Infinity, maxBodyLengthError, formBoundary);
                // Blob.type lowercases its value, including a case-sensitive boundary.
                // Retain the caller's header when an explicit boundary was serialized.
                headers.setContentType(formBoundary === undefined ? data.type : formContentType);
                requestContentLength = data.size;
              }

              // Enforce maxBodyLength against known-size bodies before dispatch using
              // the body's *actual* size — never a caller-declared Content-Length,
              // which could under-report to slip an oversized body past the check.
              // Unknown-size streams return undefined here and are counted per-chunk
              // below as fetch consumes them.
              if (!(hasMaxBodyLength && method !== 'get' && method !== 'head')) {
                _context4.n = 4;
                break;
              }
              _context4.n = 3;
              return getBodyLength(data);
            case 3:
              outboundLength = _context4.v;
              if (!(typeof outboundLength === 'number' && isFinite(outboundLength))) {
                _context4.n = 4;
                break;
              }
              requestContentLength = outboundLength;
              if (!(outboundLength > maxBodyLength)) {
                _context4.n = 4;
                break;
              }
              throw maxBodyLengthError();
            case 4:
              // A streamed body under maxBodyLength must be counted as fetch consumes
              // it; its size is never trusted from a caller-declared Content-Length.
              mustEnforceStreamBody = hasMaxBodyLength && (utils$1.isReadableStream(data) || utils$1.isStream(data));
              trackRequestStream = function trackRequestStream(stream, onProgress, flush) {
                return trackStream(stream, DEFAULT_CHUNK_SIZE, function (loadedBytes) {
                  if (hasMaxBodyLength && loadedBytes > maxBodyLength) {
                    throw pendingBodyError = maxBodyLengthError();
                  }
                  onProgress && onProgress(loadedBytes);
                }, flush);
              };
              if (!(supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody))) {
                _context4.n = 8;
                break;
              }
              if (!(requestContentLength == null)) {
                _context4.n = 6;
                break;
              }
              _context4.n = 5;
              return resolveBodyLength(headers, data);
            case 5:
              _t3 = _context4.v;
              _context4.n = 7;
              break;
            case 6:
              _t3 = requestContentLength;
            case 7:
              requestContentLength = _t3;
              // A declared length of 0 is only trusted to skip the wrap when we are
              // not enforcing a stream limit (which must not rely on that header).
              if (requestContentLength !== 0 || mustEnforceStreamBody) {
                _request = new Request(url, {
                  method: 'POST',
                  body: data,
                  duplex: 'half'
                });
                if (utils$1.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
                  headers.setContentType(contentTypeHeader);
                }
                if (_request.body) {
                  _ref5 = onUploadProgress && progressEventDecorator(requestContentLength, progressEventReducer(asyncDecorator(onUploadProgress))) || [], _ref6 = _slicedToArray(_ref5, 2), onProgress = _ref6[0], flush = _ref6[1];
                  data = trackRequestStream(_request.body, onProgress, flush);
                }
              }
              _context4.n = 10;
              break;
            case 8:
              if (!(mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head')) {
                _context4.n = 9;
                break;
              }
              data = trackRequestStream(data);
              _context4.n = 10;
              break;
            case 9:
              if (!(mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head')) {
                _context4.n = 10;
                break;
              }
              throw new AxiosError('Stream request bodies are not supported by the current fetch implementation', AxiosError.ERR_NOT_SUPPORT, config, request);
            case 10:
              if (!utils$1.isString(withCredentials)) {
                withCredentials = withCredentials ? 'include' : 'omit';
              }

              // Cloudflare Workers throws when credentials are defined
              // see https://github.com/cloudflare/workerd/issues/902
              isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype; // If data is FormData and Content-Type is multipart/form-data without boundary,
              // delete it so fetch can set it correctly with the boundary
              if (utils$1.isFormData(data)) {
                contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) {
                  headers["delete"]('content-type');
                }
              }

              // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
              headers.set('User-Agent', 'axios/' + VERSION, false);
              safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
              if (safeFetchOptions) {
                // These options are owned by Axios and are already reflected in the
                // resolved Request passed to fetch.
                delete safeFetchOptions.body;
                delete safeFetchOptions.headers;
                delete safeFetchOptions.method;
                delete safeFetchOptions.signal;
                delete safeFetchOptions.duplex;
                delete safeFetchOptions.credentials;
              }
              resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: toByteStringHeaderObject(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
              });
              if (isRequestSupported) {
                utils$1.forEach(requestDefaults, function (value, key) {
                  if (resolvedOptions[key] === undefined) {
                    resolvedOptions[key] = value;
                  }
                });
                if (resolvedOptions.signal === undefined) {
                  resolvedOptions.signal = null;
                }
                if (resolvedOptions.body === undefined) {
                  resolvedOptions.body = null;
                }
              }
              if (maxRedirects === 0) {
                resolvedOptions.redirect = 'manual';
                if (safeFetchOptions) {
                  safeFetchOptions.redirect = 'manual';
                }
              }
              request = isRequestSupported && new Request(url, resolvedOptions);
              _context4.n = 11;
              return isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions);
            case 11:
              response = _context4.v;
              responseHeaders = AxiosHeaders.from(response.headers); // Cheap pre-check: if the server honestly declares a content-length that
              // already exceeds the cap, reject before we start streaming.
              if (!hasMaxContentLength) {
                _context4.n = 12;
                break;
              }
              declaredLength = utils$1.toFiniteNumber(responseHeaders.getContentLength());
              if (!(declaredLength != null && declaredLength > maxContentLength)) {
                _context4.n = 12;
                break;
              }
              throw new AxiosError('maxContentLength size of ' + maxContentLength + ' exceeded', AxiosError.ERR_BAD_RESPONSE, config, request);
            case 12:
              isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
              if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                options = {};
                ['status', 'statusText', 'headers'].forEach(function (prop) {
                  options[prop] = response[prop];
                });
                responseContentLength = utils$1.toFiniteNumber(responseHeaders.getContentLength());
                _ref7 = onDownloadProgress && progressEventDecorator(responseContentLength, progressEventReducer(asyncDecorator(onDownloadProgress), true)) || [], _ref8 = _slicedToArray(_ref7, 2), _onProgress = _ref8[0], _flush = _ref8[1];
                bytesRead = 0;
                onChunkProgress = function onChunkProgress(loadedBytes) {
                  if (hasMaxContentLength) {
                    bytesRead = loadedBytes;
                    if (bytesRead > maxContentLength) {
                      throw pendingResponseError = new AxiosError('maxContentLength size of ' + maxContentLength + ' exceeded', AxiosError.ERR_BAD_RESPONSE, config, request);
                    }
                  }
                  _onProgress && _onProgress(loadedBytes);
                };
                response = new Response(trackStream(response.body, DEFAULT_CHUNK_SIZE, onChunkProgress, function () {
                  _flush && _flush();
                  unsubscribe && unsubscribe();
                }), options);
              }
              responseType = responseType || 'text';
              _context4.n = 13;
              return resolvers[utils$1.findKey(resolvers, responseType) || 'text'](response, config);
            case 13:
              responseData = _context4.v;
              if (!(hasMaxContentLength && !supportsResponseStream && !isStreamResponse)) {
                _context4.n = 14;
                break;
              }
              if (responseData != null) {
                if (typeof responseData.byteLength === 'number') {
                  materializedSize = responseData.byteLength;
                } else if (typeof responseData.size === 'number') {
                  materializedSize = responseData.size;
                } else if (typeof responseData === 'string') {
                  materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
              }
              if (!(typeof materializedSize === 'number' && materializedSize > maxContentLength)) {
                _context4.n = 14;
                break;
              }
              throw new AxiosError('maxContentLength size of ' + maxContentLength + ' exceeded', AxiosError.ERR_BAD_RESPONSE, config, request);
            case 14:
              !isStreamResponse && unsubscribe && unsubscribe();
              _context4.n = 15;
              return new Promise(function (resolve, reject) {
                settle(resolve, reject, {
                  data: responseData,
                  headers: AxiosHeaders.from(response.headers),
                  status: response.status,
                  statusText: response.statusText,
                  config: config,
                  request: request
                });
              });
            case 15:
              return _context4.a(2, _context4.v);
            case 16:
              _context4.p = 16;
              _t4 = _context4.v;
              unsubscribe && unsubscribe();

              // Safari can surface fetch aborts as a DOMException-like object whose
              // branded getters throw. Prefer our composed signal reason before reading
              // the caught error, preserving timeout vs cancellation semantics.
              if (!(composedSignal && composedSignal.aborted && composedSignal.reason instanceof AxiosError)) {
                _context4.n = 17;
                break;
              }
              canceledError = composedSignal.reason;
              canceledError.config = config;
              request && (canceledError.request = request);
              if (_t4 !== canceledError) {
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                  __proto__: null,
                  value: _t4,
                  writable: true,
                  enumerable: false,
                  configurable: true
                });
              }
              throw canceledError;
            case 17:
              if (!pendingBodyError) {
                _context4.n = 18;
                break;
              }
              request && !pendingBodyError.request && (pendingBodyError.request = request);
              throw pendingBodyError;
            case 18:
              if (!pendingResponseError) {
                _context4.n = 19;
                break;
              }
              throw pendingResponseError;
            case 19:
              if (!(_t4 instanceof AxiosError)) {
                _context4.n = 20;
                break;
              }
              request && !_t4.request && (_t4.request = request);
              throw _t4;
            case 20:
              if (!(_t4 && _t4.name === 'TypeError' && /Load failed|fetch/i.test(_t4.message))) {
                _context4.n = 21;
                break;
              }
              networkError = new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, _t4 && _t4.response); // Non-enumerable to match native Error `cause` semantics so loggers
              // don't recurse into circular fetch internals (see #7205).
              Object.defineProperty(networkError, 'cause', {
                __proto__: null,
                value: _t4.cause || _t4,
                writable: true,
                enumerable: false,
                configurable: true
              });
              throw networkError;
            case 21:
              throw AxiosError.from(_t4, _t4 && _t4.code, config, request, _t4 && _t4.response);
            case 22:
              return _context4.a(2);
          }
        }, _callee4, null, [[1, 16]]);
      }));
      return function (_x5) {
        return _ref4.apply(this, arguments);
      };
    }();
  };
  var seedCache = new Map();
  var getFetch = function getFetch(config) {
    var env = Object.create(null);
    var configuredEnv = config && utils$1.hasOwnProp(config, 'env') && config.env;
    ['fetch', 'Request', 'Response', 'Blob'].forEach(function (key) {
      if (configuredEnv && utils$1.hasOwnProp(configuredEnv, key)) {
        env[key] = configuredEnv[key];
      }
    });
    var fetch = env.fetch,
      Request = env.Request,
      Response = env.Response,
      Blob = env.Blob;
    var seeds = [Request, Response, fetch, Blob];
    var len = seeds.length,
      i = len,
      seed,
      target,
      map = seedCache;
    while (i--) {
      seed = seeds[i];
      target = map.get(seed);
      target === undefined && map.set(seed, target = i ? new Map() : factory(env));
      map = target;
    }
    return target;
  };
  getFetch();

  /**
   * Known adapters mapping.
   * Provides environment-specific adapters for Axios:
   * - `http` for Node.js
   * - `xhr` for browsers
   * - `fetch` for fetch API-based requests
   *
   * @type {Object<string, Function|Object>}
   */
  var knownAdapters = {
    http: httpAdapter,
    xhr: xhrAdapter,
    fetch: {
      get: getFetch
    }
  };

  // Assign adapter names for easier debugging and identification
  utils$1.forEach(knownAdapters, function (fn, value) {
    if (fn) {
      try {
        // Null-proto descriptors so a polluted Object.prototype.get cannot turn
        // these data descriptors into accessor descriptors on the way in.
        Object.defineProperty(fn, 'name', {
          __proto__: null,
          value: value
        });
      } catch (e) {
        // eslint-disable-next-line no-empty
      }
      Object.defineProperty(fn, 'adapterName', {
        __proto__: null,
        value: value
      });
    }
  });

  /**
   * Render a rejection reason string for unknown or unsupported adapters
   *
   * @param {string} reason
   * @returns {string}
   */
  var renderReason = function renderReason(reason) {
    return "- ".concat(reason);
  };

  /**
   * Check if the adapter is resolved (function, null, or false)
   *
   * @param {Function|null|false} adapter
   * @returns {boolean}
   */
  var isResolvedHandle = function isResolvedHandle(adapter) {
    return utils$1.isFunction(adapter) || adapter === null || adapter === false;
  };

  /**
   * Get the first suitable adapter from the provided list.
   * Tries each adapter in order until a supported one is found.
   * Throws an AxiosError if no adapter is suitable.
   *
   * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
   * @param {Object} config - Axios request configuration
   * @throws {AxiosError} If no suitable adapter is available
   * @returns {Function} The resolved adapter function
   */
  function getAdapter(adapters, config) {
    adapters = utils$1.isArray(adapters) ? adapters : [adapters];
    var _adapters = adapters,
      length = _adapters.length;
    var nameOrAdapter;
    var adapter;
    var rejectedReasons = {};
    for (var i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      var id = void 0;
      adapter = nameOrAdapter;
      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
        if (adapter === undefined) {
          throw new AxiosError("Unknown adapter '".concat(id, "'"));
        }
      }
      if (adapter && (utils$1.isFunction(adapter) || (adapter = adapter.get(config)))) {
        break;
      }
      rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
      var reasons = Object.entries(rejectedReasons).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          id = _ref2[0],
          state = _ref2[1];
        return "adapter ".concat(id, " ") + (state === false ? 'is not supported by the environment' : 'is not available in the build');
      });
      var s = length ? reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0]) : 'as no adapter specified';
      throw new AxiosError("There is no suitable adapter to dispatch the request " + s, AxiosError.ERR_NOT_SUPPORT);
    }
    return adapter;
  }

  /**
   * Exports Axios adapters and utility to resolve an adapter
   */
  var adapters = {
    /**
     * Resolve an adapter from a list of adapter names or functions.
     * @type {Function}
     */
    getAdapter: getAdapter,
    /**
     * Exposes all known adapters
     * @type {Object<string, Function|Object>}
     */
    adapters: knownAdapters
  };

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   *
   * @param {Object} config The config that is to be used for the request
   *
   * @returns {void}
   */
  function throwIfCancellationRequested(config) {
    if (config.cancelToken) {
      config.cancelToken.throwIfRequested();
    }
    if (config.signal && config.signal.aborted) {
      throw new CanceledError(null, config);
    }
  }

  /**
   * Milliseconds elapsed since `start`, floored at zero.
   *
   * Wall-clock, to match the rest of the codebase (speedometer, throttle,
   * AxiosTransformStream). A backwards clock adjustment mid-request would
   * otherwise produce a negative duration, so the result is clamped.
   *
   * @param {number} start Timestamp from `Date.now()`
   *
   * @returns {number} Non-negative elapsed milliseconds
   */
  function elapsedSince(start) {
    return Math.max(0, Date.now() - start);
  }

  /**
   * Dispatch a request to the server using the configured adapter.
   *
   * @param {object} config The config that is to be used for the request
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  function dispatchRequest(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    var config = utils$1.toSafeFlatObject(_config);
    throwIfCancellationRequested(config);
    config.headers = AxiosHeaders.from(utils$1.getSafeProp(config, 'headers'));

    // Transform request data
    config.data = transformData.call(config, config.transformRequest);
    if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
      config.headers.setContentType('application/x-www-form-urlencoded', false);
    }
    var adapter = adapters.getAdapter(config.adapter || defaults.adapter, config);
    var start = Date.now();
    return adapter(config).then(function onAdapterResolution(response) {
      throwIfCancellationRequested(config);
      response.duration = elapsedSince(start);

      // Expose the current response on config so that transformResponse can
      // attach it to any AxiosError it throws (e.g. on JSON parse failure).
      // We clean it up afterwards to avoid polluting the config object.
      config.response = response;
      try {
        response.data = transformData.call(config, config.transformResponse, response);
      } finally {
        delete config.response;
      }
      response.headers = AxiosHeaders.from(response.headers);
      return response;
    }, function onAdapterRejection(reason) {
      if (!isCancel(reason)) {
        throwIfCancellationRequested(config);

        // Transform response data
        if (reason && reason.response) {
          reason.response.duration = elapsedSince(start);
          config.response = reason.response;
          try {
            reason.response.data = transformData.call(config, config.transformResponse, reason.response);
          } finally {
            delete config.response;
          }
          reason.response.headers = AxiosHeaders.from(reason.response.headers);
        }
      }
      return Promise.reject(reason);
    });
  }

  var validators$1 = {};

  // eslint-disable-next-line func-names
  ['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (type, i) {
    validators$1[type] = function validator(thing) {
      return _typeof(thing) === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
  });
  var deprecatedWarnings = {};

  /**
   * Transitional option validator
   *
   * @param {function|boolean?} validator - set to false if the transitional option has been removed
   * @param {string?} version - deprecated version / removed since version
   * @param {string?} message - some message with additional info
   *
   * @returns {function}
   */
  validators$1.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
      return '[Axios v' + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }

    // eslint-disable-next-line func-names
    return function (value, opt, opts) {
      if (validator === false) {
        throw new AxiosError(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), AxiosError.ERR_DEPRECATED);
      }
      if (version && !deprecatedWarnings[opt]) {
        deprecatedWarnings[opt] = true;
        // eslint-disable-next-line no-console
        console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
      }
      return validator ? validator(value, opt, opts) : true;
    };
  };
  validators$1.spelling = function spelling(correctSpelling) {
    return function (value, opt) {
      // eslint-disable-next-line no-console
      console.warn("".concat(opt, " is likely a misspelling of ").concat(correctSpelling));
      return true;
    };
  };

  /**
   * Assert object's properties type
   *
   * @param {object} options
   * @param {object} schema
   * @param {boolean?} allowUnknown
   *
   * @returns {object}
   */

  function assertOptions(options, schema, allowUnknown) {
    if (_typeof(options) !== 'object' || options === null) {
      throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
    }
    var keys = Object.keys(options);
    var i = keys.length;
    while (i-- > 0) {
      var opt = keys[i];
      // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
      // a non-function validator and cause a TypeError.
      var validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
      if (validator) {
        var value = options[opt];
        var result = value === undefined || validator(value, opt, options);
        if (result !== true) {
          throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
        }
        continue;
      }
      if (allowUnknown !== true) {
        throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
      }
    }
  }
  var validator = {
    assertOptions: assertOptions,
    validators: validators$1
  };

  var validators = validator.validators;

  // Recognize header maps without consuming objects intended as literal values.
  // AxiosHeaders from other builds share a brand and header-container interface,
  // but not constructor identity. A tag and toJSON alone can describe a literal.
  var isHeadersBucket = function isHeadersBucket(value) {
    if (value == null || utils$1.isPlainObject(value) || value instanceof AxiosHeaders) {
      return true;
    }
    try {
      return utils$1.isObject(value) && utils$1.getSafeProp(value, Symbol.toStringTag) === 'AxiosHeaders' && ['toJSON', 'set', 'get', 'has', 'delete', 'clear', 'normalize', 'concat', 'toString', Symbol.iterator].every(function (method) {
        return utils$1.isFunction(utils$1.getSafeProp(value, method));
      });
    } catch (e) {
      // A failed optional brand probe must not prevent literal header serialization.
      return false;
    }
  };

  /**
   * Create a new instance of Axios
   *
   * @param {Object} instanceConfig The default config for the instance
   *
   * @return {Axios} A new instance of Axios
   */
  var Axios = /*#__PURE__*/function () {
    function Axios(instanceConfig) {
      _classCallCheck(this, Axios);
      this.defaults = instanceConfig || {};
      this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
      };
    }

    /**
     * Dispatch a request
     *
     * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
     * @param {?Object} config
     *
     * @returns {Promise} The Promise to be fulfilled
     */
    return _createClass(Axios, [{
      key: "request",
      value: (function () {
        var _request2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(configOrUrl, config) {
          var dummy, dummyStack, stack, firstNewlineIndex, _firstNewlineIndex, secondNewlineIndex, duplicateCheckSuffix, currentStack, causeIndex, stackHead, causeSection, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                _context.p = 0;
                _context.n = 1;
                return this._request(configOrUrl, config);
              case 1:
                return _context.a(2, _context.v);
              case 2:
                _context.p = 2;
                _t = _context.v;
                if (_t instanceof Error) {
                  try {
                    dummy = {};
                    Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                    dummyStack = dummy.stack;
                    stack = ''; // slice off the Error: ... line
                    if (typeof dummyStack === 'string') {
                      firstNewlineIndex = dummyStack.indexOf('\n');
                      stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                    }
                    if (!_t.stack) {
                      _t.stack = stack;
                    } else if (stack) {
                      // Match a common suffix after the 2 top frames when available,
                      // otherwise compare the full reconstructed stack.
                      _firstNewlineIndex = stack.indexOf('\n');
                      secondNewlineIndex = _firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', _firstNewlineIndex + 1);
                      duplicateCheckSuffix = secondNewlineIndex === -1 ? stack : stack.slice(secondNewlineIndex + 1); // `AxiosError.from()` may have already inlined the wrapped error's
                      // stack under a `Caused by:` marker. Keep the reconstructed caller
                      // frames ahead of that marker so stack-only reporters do not read
                      // them as part of the low-level cause.
                      currentStack = String(_t.stack);
                      causeIndex = getCauseStackIndex(_t, currentStack);
                      stackHead = causeIndex === -1 ? currentStack : currentStack.slice(0, causeIndex);
                      causeSection = causeIndex === -1 ? '' : currentStack.slice(causeIndex);
                      if (!stackHead.endsWith(duplicateCheckSuffix)) {
                        _t.stack = stackHead + '\n' + stack + causeSection;
                      }
                    }
                  } catch (e) {
                    // Ignore failures from custom stack hooks or un-writable stack properties.
                  }
                }
                throw _t;
              case 3:
                return _context.a(2);
            }
          }, _callee, this, [[0, 2]]);
        }));
        function request(_x, _x2) {
          return _request2.apply(this, arguments);
        }
        return request;
      }())
    }, {
      key: "_request",
      value: function _request(configOrUrl, config) {
        var _this = this;
        /*eslint no-param-reassign:0*/
        // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
          config = config || {};
          config.url = configOrUrl;
        } else {
          config = configOrUrl || {};
        }
        config = mergeConfig(this.defaults, config);
        var _config = config,
          transitional = _config.transitional,
          paramsSerializer = _config.paramsSerializer,
          headers = _config.headers;
        if (transitional !== undefined) {
          validator.assertOptions(transitional, {
            silentJSONParsing: validators.transitional(validators["boolean"]),
            forcedJSONParsing: validators.transitional(validators["boolean"]),
            clarifyTimeoutError: validators.transitional(validators["boolean"]),
            legacyInterceptorReqResOrdering: validators.transitional(validators["boolean"]),
            advertiseZstdAcceptEncoding: validators.transitional(validators["boolean"]),
            validateStatusUndefinedResolves: validators.transitional(validators["boolean"]),
            encodeBasicAuthUsername: validators.transitional(validators["boolean"])
          }, false);
        }
        if (paramsSerializer != null) {
          if (utils$1.isFunction(paramsSerializer)) {
            config.paramsSerializer = {
              serialize: paramsSerializer
            };
          } else {
            validator.assertOptions(paramsSerializer, {
              encode: validators["function"],
              serialize: validators["function"]
            }, true);
          }
        }

        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ; else if (utils$1.hasOwnProp(this.defaults, 'allowAbsoluteUrls') && this.defaults.allowAbsoluteUrls !== undefined) {
          config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        } else {
          config.allowAbsoluteUrls = true;
        }
        validator.assertOptions(config, {
          baseUrl: validators.spelling('baseURL'),
          withXsrfToken: validators.spelling('withXSRFToken')
        }, true);

        // Set config.method
        config.method = (utils$1.getSafeProp(config, 'method') || utils$1.getSafeProp(this.defaults, 'method') || 'get').toLowerCase();

        // Flatten header defaults without consuming literal method-named headers.
        var commonHeaders = utils$1.getSafeProp(headers, 'common');
        var methodHeaders = utils$1.getSafeProp(headers, config.method);
        var contextHeaders = headers && utils$1.merge(isHeadersBucket(commonHeaders) ? commonHeaders : undefined, isHeadersBucket(methodHeaders) ? methodHeaders : undefined);
        headers && utils$1.forEach(methodList.concat('common'), function (method) {
          if (isHeadersBucket(utils$1.getSafeProp(headers, method))) {
            delete headers[method];
          }
        });
        config.headers = AxiosHeaders.concat(contextHeaders, headers);

        // filter out skipped interceptors
        var requestInterceptorChain = [];
        var synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
          if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
            return;
          }
          synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
          var transitional = config.transitional || transitionalDefaults;
          var legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
          if (legacyInterceptorReqResOrdering) {
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
          } else {
            requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
          }
        });
        var responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
          responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        var promise;
        var i = 0;
        var len;
        if (!synchronousRequestInterceptors) {
          var chain = [dispatchRequest.bind(this), undefined];
          chain.unshift.apply(chain, requestInterceptorChain);
          chain.push.apply(chain, responseInterceptorChain);
          len = chain.length;
          promise = Promise.resolve(config);
          while (i < len) {
            promise = promise.then(chain[i++], chain[i++]);
          }
          return promise;
        }
        len = requestInterceptorChain.length;
        var newConfig = config;
        while (i < len) {
          var onFulfilled = requestInterceptorChain[i++];
          var onRejected = requestInterceptorChain[i++];
          try {
            newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
          } catch (error) {
            if (!onRejected) {
              promise = Promise.reject(error);
              break;
            }
            try {
              var rejectedResult = onRejected.call(this, error);
              if (utils$1.isThenable(rejectedResult)) {
                promise = Promise.resolve(rejectedResult).then(function () {
                  return dispatchRequest.call(_this, newConfig);
                });
              }
            } catch (rejectedError) {
              promise = Promise.reject(rejectedError);
            }
            break;
          }
        }
        if (!promise) {
          try {
            promise = dispatchRequest.call(this, newConfig);
          } catch (error) {
            promise = Promise.reject(error);
          }
        }
        i = 0;
        len = responseInterceptorChain.length;
        while (i < len) {
          promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        }
        return promise;
      }
    }, {
      key: "getUri",
      value: function getUri(config) {
        config = mergeConfig(this.defaults, config);
        var fullPath = buildFullPath(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return buildURL(fullPath, config.params, config.paramsSerializer);
      }
    }]);
  }(); // Provide aliases for supported request methods
  utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
    /*eslint func-names:0*/
    Axios.prototype[method] = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(url, config) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, this.request(mergeConfig(config || {}, {
                method: method,
                url: url,
                data: config && utils$1.hasOwnProp(config, 'data') ? config.data : undefined
              })));
          }
        }, _callee2, this);
      }));
      return function (_x3, _x4) {
        return _ref.apply(this, arguments);
      };
    }();
  });
  utils$1.forEach(['post', 'put', 'patch', 'query'], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
      return /*#__PURE__*/function () {
        var _httpMethod = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(url, data, config) {
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                return _context3.a(2, this.request(mergeConfig(config || {}, {
                  method: method,
                  headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                  } : {},
                  url: url,
                  data: data
                })));
            }
          }, _callee3, this);
        }));
        function httpMethod(_x5, _x6, _x7) {
          return _httpMethod.apply(this, arguments);
        }
        return httpMethod;
      }();
    }
    Axios.prototype[method] = generateHTTPMethod();

    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') {
      Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
    }
  });

  /**
   * A `CancelToken` is an object that can be used to request cancellation of an operation.
   *
   * @param {Function} executor The executor function.
   *
   * @returns {CancelToken}
   */
  var CancelToken = /*#__PURE__*/function () {
    function CancelToken(executor) {
      _classCallCheck(this, CancelToken);
      if (typeof executor !== 'function') {
        throw new TypeError('executor must be a function.');
      }
      var resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      var token = this;

      // eslint-disable-next-line func-names
      this.promise.then(function (cancel) {
        if (!token._listeners) return;
        var i = token._listeners.length;
        while (i-- > 0) {
          token._listeners[i](cancel);
        }
        token._listeners = null;
      });

      // eslint-disable-next-line func-names
      this.promise.then = function (onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function (resolve) {
          token.subscribe(resolve);
          _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
          token.unsubscribe(_resolve);
        };
        return promise;
      };
      executor(function cancel(message, config, request) {
        if (token.reason) {
          // Cancellation has already been requested
          return;
        }
        token.reason = new CanceledError(message, config, request);
        resolvePromise(token.reason);
      });
    }

    /**
     * Throws a `CanceledError` if cancellation has been requested.
     */
    return _createClass(CancelToken, [{
      key: "throwIfRequested",
      value: function throwIfRequested() {
        if (this.reason) {
          throw this.reason;
        }
      }

      /**
       * Subscribe to the cancel signal
       */
    }, {
      key: "subscribe",
      value: function subscribe(listener) {
        if (this.reason) {
          listener(this.reason);
          return;
        }
        if (this._listeners) {
          this._listeners.push(listener);
        } else {
          this._listeners = [listener];
        }
      }

      /**
       * Unsubscribe from the cancel signal
       */
    }, {
      key: "unsubscribe",
      value: function unsubscribe(listener) {
        if (!this._listeners) {
          return;
        }
        var index = this._listeners.indexOf(listener);
        if (index !== -1) {
          this._listeners.splice(index, 1);
        }
      }
    }, {
      key: "toAbortSignal",
      value: function toAbortSignal() {
        var _this = this;
        var controller = new AbortController();
        var abort = function abort(err) {
          controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = function () {
          return _this.unsubscribe(abort);
        };
        return controller.signal;
      }

      /**
       * Returns an object that contains a new `CancelToken` and a function that, when called,
       * cancels the `CancelToken`.
       */
    }], [{
      key: "source",
      value: function source() {
        var cancel;
        var token = new CancelToken(function executor(c) {
          cancel = c;
        });
        return {
          token: token,
          cancel: cancel
        };
      }
    }]);
  }();

  /**
   * Syntactic sugar for invoking a function and expanding an array for arguments.
   *
   * Common use case would be to use `Function.prototype.apply`.
   *
   *  ```js
   *  function f(x, y, z) {}
   *  const args = [1, 2, 3];
   *  f.apply(null, args);
   *  ```
   *
   * With `spread` this example can be re-written.
   *
   *  ```js
   *  spread(function(x, y, z) {})([1, 2, 3]);
   *  ```
   *
   * @param {Function} callback
   *
   * @returns {Function}
   */
  function spread(callback) {
    return function wrap(arr) {
      return callback.apply(null, arr);
    };
  }

  /**
   * Determines whether the payload is an error thrown by Axios
   *
   * @param {*} payload The value to test
   *
   * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
   */
  function isAxiosError(payload) {
    return utils$1.isObject(payload) && payload.isAxiosError === true;
  }

  var HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
     * @deprecated Use `ContentTooLarge` instead.
     */
    PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
     * @deprecated Use `UnprocessableContent` instead.
     */
    UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
  };
  Object.entries(HttpStatusCode).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (HttpStatusCode[value] === undefined) {
      HttpStatusCode[value] = key;
    }
  });

  /**
   * Create an instance of Axios
   *
   * @param {Object} defaultConfig The default config for the instance
   *
   * @returns {Axios} A new instance of Axios
   */
  function createInstance(defaultConfig) {
    var context = new Axios(defaultConfig);
    var instance = bind(Axios.prototype.request, context);

    // Copy axios.prototype to instance
    utils$1.extend(instance, Axios.prototype, context, {
      allOwnKeys: true
    });

    // Copy context to instance
    utils$1.extend(instance, context, null, {
      allOwnKeys: true
    });

    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
      return createInstance(mergeConfig(defaultConfig, instanceConfig));
    };
    return instance;
  }

  // Create the default instance to be exported
  var axios = createInstance(defaults);

  // Expose Axios class to allow class inheritance
  axios.Axios = Axios;

  // Expose Cancel & CancelToken
  axios.CanceledError = CanceledError;
  axios.CancelToken = CancelToken;
  axios.isCancel = isCancel;
  axios.VERSION = VERSION;
  axios.toFormData = toFormData;

  // Expose AxiosError class
  axios.AxiosError = AxiosError;

  // alias for CanceledError for backward compatibility
  axios.Cancel = axios.CanceledError;

  // Expose all/spread
  axios.all = function all(promises) {
    return Promise.all(promises);
  };
  axios.spread = spread;

  // Expose isAxiosError
  axios.isAxiosError = isAxiosError;

  // Expose mergeConfig
  axios.mergeConfig = mergeConfig;
  axios.AxiosHeaders = AxiosHeaders;
  axios.formToJSON = function (thing) {
    return formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);
  };
  axios.getAdapter = adapters.getAdapter;
  axios.HttpStatusCode = HttpStatusCode;
  axios["default"] = axios;

  return axios;

}));



//////////////////
// WEBPACK FOOTER
// ./~/axios/dist/axios.js
// module id = 175
// module chunks = 1